import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { BaseService } from 'src/app/core/services/base.service';
import { Location } from '@angular/common';
import { Config } from 'src/app/config/constants';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss'],
  providers: [DatePipe]
})
export class AccountInfoComponent implements OnInit {
  urlSafe: SafeResourceUrl;
  agentcbtn:boolean=true;
  hidecircle:boolean=true;
  userNamechangeval:any;
  dashboardList=[];
  error: any;
  leadMgaId: any;
  dropdownSettingsLanguages={};
  dropdownSettingsPLicensed={}
  id: any;
  errormob="";

  uploadLicensePopup : any;
  viewUploadedLicensePopup : any;
  uploadEOPopup : any;
  viewUploadedEOPopup : any;
  uploadVoidChequePopup :any;
  licencesType: any;
  show1: boolean=false;
  type1 = "password";

  


  fileExtensionENO: any;
  fileExtensionErrorENO: boolean = false;
  fileExtensionMessageENO: any;
  fileenoName: string;
  FileDataList: any;
  showemailErrorMsg: boolean;
  showdateErrorMsg: boolean;
  showEffectivedateErrorMsg: boolean;
  acceptedExtensions = ["jpg", "jpeg", "png", "pdf", "docx", "JPG", "JPEG", "PNG", "PDF", "DOCX"];
  fileeno: any;
  expiryDate1: any;
  effectiveDate1: any;
  policyNumber: any;
  minDate = new Date();
  productPhotofile: any;
  productPhotofile1: any;
  loading: boolean;
  BankInfo :boolean = false;
  EditBankInfo :boolean = false;
  // banking info
  voidIndexitem: any;
  indexno: any;
  // BankName: any;
  // holderName: any;
  // branchAddress: any;
  confirmaccountNo: any;
  confirmaccountNoErrMsg: boolean=false;
  transitNo: any;
  financialInstitutionNo: any ;
  accountNo: any;
  // holderNameErrMsg: boolean=false;
  // BankNameErrMsg: boolean=false;
  // branchAddressErrMsg: boolean=false;
  transitNoErrMsg: boolean=false;
  financialInstitutionNoErrMsg: boolean=false;
  accountNoErrMsg: boolean=false;
  bankName : any;
  popupName="Add";
  btnPopupName ="Save"
  btncancelPopupName ="Cancel"
  // end banking info
  fileeno1: any;
  expiryDate: any;
  msgfinal: any;
  msg: any;
  filelicens: any;
  showemailErrorMsgone: boolean;
  
  province: any;
  showExpiry: any;
  showExpiry1: any;
  showDocumentName: any;
  showDocumentName1: any;
  finalDocs: any;
  finalDocs1: any;
  showPolicyNumber: any;
  uploadlicenseArray: Array<any> = [];
  licenseName: any;
 
  deleteModal: any;
  fileenoNameLic: any;
  fileenoName1: any;
  newAttribute: any = {};
  newAttributenext: any = {};
  showlicpErrorMsgone: boolean = false;
  showlictErrorMsgone:boolean =false;
  FileDataList1: any;
  showemailErrorMsg1: boolean = false;
  uploadvoidchequeArray: Array<any> = [];
  pdfmodel:boolean=false;
  pdfmodel1:boolean=false;
  pdfmodel2:boolean=false;
  pdfmodel3:boolean=false;
  LeadActivated: any;
  documentId: any;
  fileId: any;
  fileIdlic: any;
licenceId: any;
fileIdvoid:any;
voidchequeId:any;
showAgency: boolean=false;
showCompany: boolean=false;
  companyName: any;
  commitionTo: any;
  b2cLinkRequest: any;
  b2cLink: any;
  commissionsTo: any;
  showCompanyDelete:boolean=false;
  isAnyUpdate:boolean=false;
  searchString: any="All";
  searchStringForLead : any;
  searchName: any;
  getPaymentHsry: any;
  sortDir:any="desc";
  sortBy: any="createdAt";
  page: any = 0;
  size: any = 30;
  p: any =0;
  ascSortApplied:boolean=false;
  descSortApplied:boolean=false;
  historyTotal: any;
  mgaId: any;
  editMGAShortName: boolean=false;
  callMgaAPI: boolean=false;
  isOverWriteEO: boolean=false;
  documentType: any;  
  todayDate: Date;
  bankNm: any;
  holdeNm: any;
  holderNm: any;
  branchAdr: any;
  transitNm: any;
  financialInstNumber: any;
  accNm: any;
  confirmAccNo: any;
  paymentTabRedDot : any;

  showEdit:boolean=true;
  showSave:boolean=false;
  LicReqRedDot:boolean=false;
  effectiveDate: string;
  oricid: any;
  brokerLinkMGA: any=[];
  mgaIndex: any=0;
  agencyIndex: any=0;
  brokerLinkMGAAgency: any=[];
  requestedData: any;
  isDocumentRequested: boolean=false;
  otpTimerDisplaySIN: string = '';
  otpTimerSIN: any;
  remainingSecondsSIN: number = 300;
  isOtpExpiredSIN: boolean = false;
  constructor(public router: Router, public user: UserService,private location: Location, public config: Config, private DatePipe:DatePipe, private route: ActivatedRoute,private base: BaseService,private toastr: ToastrService) { 
    this.todayDate = new Date();
  }

  
  ngOnInit(): void {
    this.leadId = sessionStorage.getItem('leadId');
   
    
    var tabclick=sessionStorage.getItem("tab3open")
    if(tabclick=="true"){
      this.openHistoryTabs(3);
      sessionStorage.removeItem("tab3open")
    }
    var tabclick1=sessionStorage.getItem("tab1open")
    if(tabclick1=="true"){
      this.openTabs(1);
      sessionStorage.removeItem("tab1open")
    }
    
    this.getDashboard();
    this.getLeadDoc();
    this.getAgreement();
    this.getAgentCode();
    this.getMiscDocument();
    this.getLicensRequest();
    this.getEORequest();
    this.getVoidChequeRequest();  
    this.getContract();
    // this.openHistoryTabs(3);
    this.dropdownSettingsLanguages = { 
      singleSelection: false, 
      text:"Select Languages",
      selectAllText:'Select All Languages',
      unSelectAllText:'UnSelect All Languages',
      enableSearchFilter: true,
      classes:"myclass inputField",
      badgeShowLimit: 15,
      
  }
  this.dropdownSettingsPLicensed = { 
    singleSelection: false, 
    text:"Select Provinced",
    selectAllText:'Select All Provinced',
    unSelectAllText:'UnSelect All Provinced',
    enableSearchFilter: true,
    classes:"myclass inputField",
    badgeShowLimit: 15,
    
}
var showDocFlag = localStorage.getItem('docViewEnable')
if(showDocFlag =='true'){
  this.openTabs(1)
}
  }
  back(): void {
    this.location.back()
  }
  onItemSelectLanguages(item: any) {
  }
  OnItemDeSelectLanguages(item: any) {
  }
  onSelectAllLanguages(items: any) {
  }
  onDeSelectAllLanguages(items: any) {
  }
  onItemSelectPL(items: any){

  }
  OnItemDeSelectPL(items: any){

  }
  onSelectAllPL(items: any){

  }
  onDeSelectAllPL(items: any){

  }

  tabs = [
    { active: 'active', tabcontent: 'tabcontent' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    { active: '', tabcontent: 'hide' },
    
    ];
  openTabs(index){
    this.callMgaAPI=false
    this.reset();
    this.tabs[index].active = 'active';
    this.tabs[index].tabcontent = 'tabcontent';
    if(index==0)
    {
      
      this.hidecircle=true;
  
    }
    else
    {
      this.hidecircle=false;
  
    }
  if(index==2 || index==3)
  {
    this.agentcbtn=false;
  }
  else
  {
    this.agentcbtn=true;
  
  }
  }
  reset() {
    for (let i = 0; this.tabs.length > i; i++) {
    this.tabs[i].active = '';
    this.tabs[i].tabcontent = 'hide';
    }
    }
    openTabs2(index){
      this.reset2();
      this.reset21();
      this.reset22();
      this.tabs2[index].active2 = 'active2';
      this.tabs2[index].tabcontent2 = 'tabcontent2';
      if(index==0){
        this.showLicTypeonPopup=this.individualLicType;
      }
      if(index==1){
        this.showLicTypeonPopup=this.corporateLicType;
      }
      if(index==2){
        this.showLicTypeonPopup=this.MgaLicType;
      }
    }

    reset2() {
      for (let i = 0; this.tabs2.length > i; i++) {
      this.tabs2[i].active2 = '';
      this.tabs2[i].tabcontent2 = 'hide';
      }
      }

      tabs2 = [
        { active2: 'active2', tabcontent2: 'tabcontent2' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        { active2: '', tabcontent2: 'hide' },
        
        ];
    firstName: any;
    lastName: any;
    middleName: any;
    languages1: any;
    agencyMgaName: any;
    positionTitle: any;
    workPhone: any;
    mobileNumber: any;
    emailAddress=[];
    website: any;
    primaryAddressCity: any;
    primaryAddressCountry: any;
    primaryAddressPostalCode: any;
    primaryAddressProvince: any;
    primaryCompleteAddress: any;
    alternativeAddressCity: any;
    alternativeAddressCountry: any;
    alternativeAddressPostalCode: any;
    alternativeAddressProvince: any;
    alternativeCompeteAddress: any;
    workPhoneExtension: any;
    salutation: any="";
    emailAddress1: any;
    tags1: any;
    ciprnumber: any;
    leadId: any;
    type: any;
    salutationData=[];
    agencyMgaData=[];
    provinceData=[];
    provinceLicensedData=[];
    languagesData=[];
    languagesArray=[];
    allPLicensedData=[];
    PLicensedArray=[];
    agencyName:any;
    mgaName:any;
  getDashboard() {
    //debugger
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
         //debugger   
        this.provinceData=data.data.provinces;
        this.salutationData=data.data.salutation;
        //this.languagesData=data.data.allLanguages;
        for (let i = 0; i < data.data.allLanguages.length; i++) {
          this.languagesData.push({ "id": data.data.allLanguages[i], "itemName": data.data.allLanguages[i] });
        }
        for (let i = 0; i < data.data.provinces.length; i++) {
          this.allPLicensedData.push({ "id": data.data.provinces[i].id, "itemName": data.data.provinces[i].provinceName });
        }

        if (data.data.leads.emailAddress != null || undefined) {
          this.emailAddress=[];
          for (var i = 0; i < data.data.leads.emailAddress.length; i++) {
            var obj = {
              "email": data.data.leads.emailAddress[i].email,
              "id": data.data.leads.emailAddress[i].id,
              "isInvalid": data.data.leads.emailAddress[i].isInvalid,
              "isOptedOut": data.data.leads.emailAddress[i].isOptedOut,
              "isPrimary": data.data.leads.emailAddress[i].isPrimary,
            }
            this.emailAddress.push(obj)
          }
        }
        // this.brokerLinkMGA = data.data.leads.brokerLinkMGAs;
        const filteredItems = data.data.leads.brokerLinkMGAs.filter(item => item.isCompnaySignUp === true);

// Step 2: Remove duplicates within the filtered items based on agencyId
const uniqueFilteredItems = filteredItems.filter((item, index, self) => 
  item.agencyId !== null &&
  index === self.findIndex(i => i.agencyId === item.agencyId)
);

// Step 3: Remove items that already exist in brokerLinkMGAAgency (to avoid pushing duplicates)
const nonDuplicateItems = uniqueFilteredItems.filter(item =>
  !this.brokerLinkMGAAgency.some(existingItem => existingItem.agencyId === item.agencyId)
);

// Step 4: Push the non-duplicate items into brokerLinkMGAAgency
this.brokerLinkMGAAgency.push(...nonDuplicateItems);


data.data.leads.brokerLinkMGAs.forEach(item => {
    // Check if the mgaId already exists in this.brokerLinkMGA
    const exists = this.brokerLinkMGA.some(existingItem => existingItem.mgaId === item.mgaId);
  
    // If it doesn't exist, push it into this.brokerLinkMGA
    if (!exists) {
      this.brokerLinkMGA.push(item);
    }
  });
        this.firstName=data.data.leads.firstName;
        this.LeadActivated=data.data.leads.leadStatus;
        this.isAnyUpdate=data.data.leads.anyUpdate;
        // if(this.LeadActivated=="Activated"){}
        // leadStatus: "Activated"
        //debugger
        this.licencesType=data.data.leads.licencesType;
        this.lastName=data.data.leads.lastName;
        this.middleName=data.data.leads.middleName;
        this.languages1=data.data.leads.languages;
        this.agencyMgaName=data.data.leads.agencyMgaName;
        this.mgaName = data.data.leads.mgaShortName;
   if(this.mgaName==null){
    this.mgaName = data.data.leads.agencyMgaName;
   }
        this.mgaId = data.data.leads.agencyMgaId;
         this.commissionsTo=data.data.commitionTo
        //         this.AgencyMGA = data.data.mga.mgaName
        //      if(!this.commissionsTo){
        //        this.commissionsTo=data.data.mga.commitionTo
        //      }
        this.positionTitle=data.data.leads.positionTitle;
        this.workPhone=data.data.leads.workPhone;
        this.mobileNumber=data.data.leads.mobileNumber;
         this.emailAddress1=data.data.leads.emailAddress[0].email;
        this.website=data.data.leads.website;
        this.b2cLink=data.data.leads.b2cLink;
        this.b2cLinkRequest=data.data.leads.b2cLinkRequest;
        this.primaryAddressCity=data.data.leads.primaryAddressCity;
        this.primaryAddressCountry=data.data.leads.primaryAddressCountry;
        this.primaryAddressPostalCode=data.data.leads.primaryAddressPostalCode;
        this.primaryAddressProvince=data.data.leads.primaryAddressProvince;
        this.primaryCompleteAddress=data.data.leads.primaryCompeteAddress;
        this.alternativeAddressCity=data.data.leads.alternativeAddressCity;
        this.alternativeAddressCountry=data.data.leads.alternativeAddressCountry;
        this.alternativeAddressPostalCode=data.data.leads.alternativeAddressPostalCode;
        this.alternativeAddressProvince=data.data.leads.alternativeAddressProvince;
        this.alternativeCompeteAddress=data.data.leads.alternativeCompeteAddress;
        this.tags1=data.data.leads.tags;
        this.workPhoneExtension=data.data.leads.workPhoneExtension;
        this.salutation=data.data.leads.salutation;
        this.ciprnumber=data.data.leads.ciprnumber;
        this.type=data.data.leads.type
        this.leadId=data.data.leads.leadId;
        this.showAgency = data.data.leads.isCompanyRegister;
        this.agencyId = data.data.leads.agencyId;
        this.companyName = data.data.leads.companyName;
        this.commissionsTo = data.data.leads.commitionTo;
        this.agencyName = data.data.leads.agencyName
        if (data.data.leads.languages != null) {
          for (let i = 0; i < data.data.leads.languages.length; i++) {
            this.languagesArray.push({ "id": data.data.leads.languages[i], "itemName": data.data.leads.languages[i]});
          }
        }
        for(let i=0; i<data.data.leads.leadProvinces.length; i++){
          // this.PLicensedArray.push(this.personalinfo.leadProvinces[i].provinces.provinceName);
          this.PLicensedArray.push({"id":data.data.leads.leadProvinces[i].provinces.id,"itemName":data.data.leads.leadProvinces[i].provinces.provinceName});
        }
        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {
            this.error = "Something went wrong. Please check username and password.";
          }
        }, () => { });
  }
  // tes(){
  //     
  //   console.log("Tes work")
  //   this.uploadLicensePopup = !this.uploadLicensePopup
  // }
  getDocuments=[];
  getLicences=[];
  getLicences1=[];
  getVoidCheck=[];
  licencesTypes:[];
  corporateLicType=[];
  MgaLicType=[];
  individualLicType=[];
  showLicTypeonPopup=[];
  getLeadDoc() {
      
    this.getDocuments=[];
      this.getLicences=[];
      this.getVoidCheck=[];
          // this.user.getDocumentDetailsLead(this.leadId).pipe()
    this.user.getdocuments().pipe()

      .subscribe(
        data => {
          this.corporateLicType=[];
          this.MgaLicType=[];
          this.individualLicType=[];
          this.showLicTypeonPopup=[];
          this.getLicences1=[];
          this.showCompany=false;
          // this.BankName = data.data.accountDetails[0]?.bankName;
          // this.holderName = data.data.accountDetails[0]?.holderName;
          // this.branchAddress = data.data.accountDetails[0]?.branchAddress;
          if(data.data.accountDetails.length!=0){
            this.transitNo = data.data.accountDetails[0]?.transitNumber;
            this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
            this.accountNo = data.data.accountDetails[0]?.accountNumber;
            this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
            this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
            this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
          }
          else{
            this.transitNo =null;
            this.financialInstitutionNo=null;
            this.accountNo=null;
            this.confirmaccountNo =null;
            this.maskaccountNo =null;
            this.eyeIconShowAccountNumber =null;
          }
          this.licencesTypes = data.data.licencesTypes;
          for(let i=0; i<data.data.licencesTypes.length; i++){
            var testOVr = data.data.licencesTypes[i].toLowerCase();
            if (testOVr.slice(-2)=='dr' || testOVr.indexOf('corporate') > -1){
              if(data.data.licencesTypes[i]!=="General 3 - DR"){
              this.corporateLicType.push(data.data.licencesTypes[i])
              this.MgaLicType.push(data.data.licencesTypes[i])
            } 
          }
            if(testOVr.indexOf('corporate') > -1){
              
            }
            else{
              this.individualLicType.push(data.data.licencesTypes[i])
            }
          }
          this.showLicTypeonPopup=this.individualLicType;
          if(data.data.documents != null){
            this.getDocuments.push(data.data.documents); 
          }
          if(data.data.licences != null){
            this.getLicences = data.data.licences;
          }
          if (this.type == 'Travel Agent') {
            this.getLicences = this.getLicences.filter(licence => {
                // Check the provinceCode for each licence and remove if it's not 'NS'
                return licence.provinces.provinceCode === 'NS';
            });
        }
          if (data.data.licences.length != 0) {
            for (var i = 0; i < data.data.licences.length; i++) {
              var obj = {}
              //this.uploadlicenseArray.push(data.data.licences[i]);
              try{obj["urltreamlic"] = data.data.licences[i].fileDownloadUrl.split('.').pop();}catch{}
              obj["createdAt"] = data.data.licences[i].createdAt;
              obj["createdBy"] = data.data.licences[i].createdBy;
              obj["description"] = data.data.licences[i].description;
              obj["expiryDate"] = data.data.licences[i].expiryDate;
              obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
              obj["fileId"] = data.data.licences[i].fileId;
              obj["fileUrl"] = data.data.licences[i].fileUrl;
              obj["id"] = data.data.licences[i].id;
              obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
              obj["licencesProvince"] = data.data.licences[i].licencesProvince;
              obj["licencesType"] = data.data.licences[i].licencesType;
              obj["licenseName"] = data.data.licences[i].licenseName;
              obj["licensesNumber"] = data.data.licences[i].licensesNumber;
              obj["status"] = data.data.licences[i].status;
              obj["type"] = data.data.licences[i].type;
              obj["updatedAt"] = data.data.licences[i].updatedAt;
              obj["provinceName"] = data.data.licences[i].provinces.provinceName;
              obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
                 
              this.uploadlicenseArray.push(obj)
            }
            
          }
          else {
            this.addFieldValue();
          }
          // if(data.data.accountDetails != null){
          //   this.getVoidCheck = data.data.accountDetails;
          // }
           if(data.data.accountDetails.length>0){
          data.data.accountDetails.forEach((voidChequeaccountDetails: any) => {
            this.getVoidCheck.push(voidChequeaccountDetails);
          });
        }
          if (data.data.accountDetails.length != 0) {
            for (var i = 0; i < data.data.accountDetails.length; i++) {
              var obj = {}
              // this.uploadvoidchequeArray.push(data.data.accountDetails[i])
              try{obj["urltreamvoid"] = data.data.accountDetails[i].fileDownloadUrl.split('.').pop();}catch{}
              obj["createdAt"] = data.data.accountDetails[i].createdAt;
              obj["createdBy"] = data.data.accountDetails[i].createdBy;
              obj["description"] = data.data.accountDetails[i].description;
              obj["documentName"] = data.data.accountDetails[i].documentName;
              obj["fileDownloadUrl"] = data.data.accountDetails[i].fileDownloadUrl;
              obj["fileId"] = data.data.accountDetails[i].fileId;
              obj["fileUrl"] = data.data.accountDetails[i].fileUrl;
              obj["id"] = data.data.accountDetails[i].id;
              obj["lastModifiedBy"] = data.data.accountDetails[i].lastModifiedBy;
              obj["status"] = data.data.accountDetails[i].status;
              obj["type"] = data.data.accountDetails[i].type;
              obj["updatedAt"] = data.data.accountDetails[i].updatedAt;
              this.uploadvoidchequeArray.push(obj)
            }
       
          }
          else {
            this.addFieldValuecheque();
          }
        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {
            this.error = "Something went wrong. Please check username and password.";
          }
        }, () => { });
  }

  getAgreementLead=[];
  getAgreement() {
this.getAgreementLead=[];
    this.user.getContractSignOFLead(this.leadId).pipe()
      .subscribe(
        data => {
          if(data.data=="No contract Found"){
            this.getAgreementLead=[]
          }else{
            this.getAgreementLead=[]
            for(let i=0; i<data.data.length;i++){
              this.getAgreementLead.push(data.data[i]);
            }
          }

        }, error => {

          if (error.status == 400 || error.status == 417) {
            this.error = error.error.data;
          }
          else {
            this.error = "Something went wrong. Please check username and password.";
          }
        }, () => { });
  }
  agreementCheckUrl: any;
  agreement: any;
  onAgreement(url, name,fileId){
        // this.voidCheckUrl = url;
        this.user.getLeadPreviewLink(fileId).pipe()
.subscribe(
    data => {
        
    //  console.log(data.data)
     this.agreementCheckUrl=data.data
 
    },error=>{
   
        if(error.status == 400 || error.status==417){
            this.error=error.error.data;
           
         }
         else{
           
           this.error="Something went wrong.";
         }
    
        },()=>{});
        this.agreement = name
        setTimeout(() => 
        {
          this.pdfmodel3 = !this.pdfmodel3;
        },
        900);
          }

  
    Edit()
  {
    this.showEdit=false;
    this.showSave=true;
  }
  Save()
  {
    this.showEdit=true;
    this.showSave=false;
  }
  Cancel()
  {
    this.showEdit=true;
    this.showSave=false;
  }

  currentpassErrorMsg() 
  {
    if (!this.oldPassword) { this.showcurrentpassErrorMsg = true; } else { this.showcurrentpassErrorMsg = false }
  }
  newpassErrorMsg() 
  {
    if (!this.newPassword) { this.shownewpassErrorMsg = true; } else { this.shownewpassErrorMsg = false };
    this.error5="";
  }

  confirmpassErrorMsg() 
  {
    if (!this.confirmPassword) { this.showconfirmpassErrorMsg = true; } else { this.showconfirmpassErrorMsg = false }
  }

  showcurrentpassErrorMsg: any;
  oldPassword: any;
  shownewpassErrorMsg: any;
  newPassword: any;
  showconfirmpassErrorMsg:any;
  confirmPassword:any;
  error5: any;

  passwordChange() 
  {
      var flag = true;
      if (!this.oldPassword || this.oldPassword == "") { this.showcurrentpassErrorMsg = true; flag = false }
      if (!this.newPassword || this.newPassword == "") { this.shownewpassErrorMsg = true; flag = false }
      if (!this.confirmPassword || this.confirmPassword == "") { this.showconfirmpassErrorMsg = true; flag = false }
      if (this.error5  != "") { flag = false }

    if(this.oldPassword == this.newPassword){
      Swal.fire('Current password and New password cannot be same!');
      flag = false;
        }
    if(this.newPassword != this.confirmPassword){
       Swal.fire('New password and Confirm password need to be same!');
       flag = false;
        }
        if (flag == true) 
        {
          this.user.updatePassword(this.oldPassword, this.newPassword)
      .pipe()
      .subscribe(
          data => {
            if(data.success==true){
           this.router.navigateByUrl('/')
         //  Swal.fire('Password is updated successfully!')
          Swal.fire("", data.data,'success')
            }
            else{
              Swal.fire('',data.data,'error')
            }
          },error=>{
            
              if(error.status == 400 || error.status==417){
                  this.error=error.error.data;
               }
               else{
 
                 this.error="Something went wrong";
               }
           
              },()=>{});

        }
   }
   passwordValidate(pass){
    this.error5=""
  //   var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).{8,15}$/;
  //   // var re = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
    
  // if (!re.test(pass.toUpperCase())) {
  // this.error5="Password is not in the required format."
  // }
  // if (!re.test(pass.match())){
  //   this.error5="Please enter valid Password"
  //   }
    if (pass.length <8){
      this.error5="Password is not in the required format."
      }
}
  showNew = false;
  typeNew = "password";
  toggleShowNew() {
    this.showNew = !this.showNew;
    if (this.showNew) {
      this.typeNew = "text";
    }
    else {
      this.typeNew = "password";
    }
  }
  toggleShow1() {
    this.show1 = !this.show1;
    if (this.show1) {
      this.type1 = "text";
    }
    else {
      this.type1 = "password";
    }
  }
  languages=[];
  allProvicesList=[];
  agencyMgaId: any
  userId: any
  leadStatus: any
  updateLead(){
    this.allProvicesList=[];
 if (this.languagesArray != null) {
      for (let i = 0; i < this.languagesArray.length; i++) {
        this.languages.push(this.languagesArray[i].id)
      }
    }
    if (this.PLicensedArray != null) {

      if (this.PLicensedArray.length > 0) {
        for (let i = 0; i < this.PLicensedArray.length; i++) {
          var obj = {};
          let temp = this.allPLicensedData.filter(itm => itm.provinceName +'-'+ itm.provinceCode == this.PLicensedArray[i].itemName)
          if (temp.length > 0) {
            obj["id"] = this.PLicensedArray[i].id;
          } else {
            obj["id"] = 0;
          }
          obj["provinces"] = this.PLicensedArray[i].id;
          this.allProvicesList.push(obj);
        }
      }

  }
  this.user.addMemberAccount(this.firstName,
    this.middleName,
    this.lastName,
    //this.personalinfo.selectedLanguage,
    this.languages,
    this.allProvicesList,
    // this.tags,
    this.primaryAddressCity,
    this.primaryAddressCountry,
    this.primaryAddressPostalCode,
    this.primaryAddressProvince,
    this.primaryCompleteAddress,
    this.workPhone,
    this.workPhoneExtension,
    this.alternativeAddressCity,
    this.alternativeAddressCountry,
    this.alternativeAddressPostalCode,
    this.alternativeAddressProvince,
    this.alternativeCompeteAddress,
    this.ciprnumber,
    this.emailAddress,
    this.mobileNumber,
    this.positionTitle,
    this.leadId,
    this.salutation,
    this.agencyMgaId = 0,
    this.userId = 0,
    this.leadStatus = 0,
    this.type,
    this.website
  )
    .pipe()
    .subscribe(
      data => {
        Swal.fire("",data.data,'success')
        this.Cancel();
       
      }, error => {
        this.PLicensedArray = [];
        this.languagesArray = [];
        this.languages = [];
        this.allProvicesList = [];
        this.getDashboard();

        if (error == "Bad Request") {
          Swal.fire("Bad Request please try again!")
        }
        else {
          Swal.fire("Something went wrong. Please check and try again!")

        }
        //  }
      }, () => { });

}
onmobclk(data){
    
  this.errormob=""
  // var re = /^\d{3}-\d{3}-\d{4}$/;
  var re = /^[0-9-+() ]*$/;
  if(!re.test(data.toLowerCase())){
    this.errormob="Not in format"
  }
  }
  removedocs(id) {
      
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        // this.showdocuments = false;
        this.user.deleteDoc(id).pipe()
          .subscribe(
            data => {
              // this.fileeno = ""
              // this.showemailErrorMsg = false
              // this.fileenoName = ""
              // this.expiryDate = ""
              // this.policyNumber = ""
              Swal.fire('Deleted!',
              'The document has been removed successfully.',
              'success')
              // this.getLeadInfo();
               this.getLeadDoc();
              //   this.getLeadSDocument();
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
      }
    })
    
  }
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  enofile:File=null;
  enoSizeCheck: boolean=false;
  FileSelect(event) {
    // this.FileDataList=event.target.files;
    // this.fileenoName=this.FileDataList[0].name;
    this.enofile = event.target.files[0];
    if(this.enofile.size>4194304){
      this.enoSizeCheck=true;

      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.enoSizeCheck=false;
      this.showemailErrorMsg=false;
    }

    if (event.target.files.length > 0) {
      this.FileDataList = event.target.files;
      this.fileenoName = this.FileDataList[0].name;

      try{this.fileExtensionENO = this.fileenoName.split('.').pop();}catch{}
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionENO)) {
        this.fileExtensionErrorENO = false;
        this.fileExtensionMessageENO = ""

        this.showemailErrorMsg = this.fileExtensionErrorENO
        this.fileenoName = this.FileDataList[0].name;
      } else {
        this.fileExtensionMessageENO = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorENO = true;
        this.showemailErrorMsg = this.fileExtensionErrorENO
        this.fileenoName = this.fileExtensionMessageENO

      }

    } else {
      this.showemailErrorMsg = false;
      this.fileenoName = ""
    }

  }
  addFieldValuecheque() {
    this.uploadvoidchequeArray.push(this.newAttributenext)
    this.newAttributenext = {};
    //this.uploaddocs2();
  }
  fileExtensionVC: any;
  fileExtensionErrorVC: boolean = false;
  fileExtensionMessageVC: any;
  voidfile:File=null;
  voidSizeCheck: boolean=false;
  FileSelect1(event, i) {
    
    if (event.target.files.length > 0) {
    //
    this.voidfile = event.target.files[0];
    if(this.voidfile.size>4194304){
      this.voidSizeCheck=true;
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }else{
      this.showemailErrorMsg1 = false;
      this.voidSizeCheck=false;
    }


    
      this.FileDataList1 = event.target.files;
      this.fileenoName1 = this.FileDataList1[0].name;

      try{this.fileExtensionVC = this.fileenoName1.split('.').pop();}catch{}
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionVC)) {
        this.fileExtensionErrorVC = false;
        this.fileExtensionMessageVC = ""

        this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
        this.fileenoName1 = this.FileDataList1[0].name;
      } else {
        this.fileExtensionMessageVC = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorVC = true;
        this.uploadvoidchequeArray[i].showemailErrorMsg1 = this.fileExtensionErrorVC
        this.fileenoName1 = this.fileExtensionMessageVC

      }

    } else {
      // this.uploadvoidchequeArray[i].showemailErrorMsg1 = false;
      // this.fileenoName1 = ""
      this.uploadvoidchequeArray[i].fileeno1=this.fileenoName1
    }
  }
  uploadEno() {
    var flag = true
    var errormsg = [];
    this.expiryDate = this.DatePipe.transform(this.expiryDate1, 'yyyy-MM-dd');
    this.effectiveDate = this.DatePipe.transform(this.effectiveDate1, 'yyyy-MM-dd');
  //  if(this.fileId==null){
      if (!this.fileeno || this.fileeno.length <= 0) { this.showemailErrorMsg = true; flag = false; errormsg.push('Choose File') }
  //  }
    if (!this.expiryDate || this.expiryDate.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!this.policyNumber || this.policyNumber.length <= 0) { this.showdateErrorMsg = true; flag = false; errormsg.push('Enter E&O Policy Number') }
    if (this.enoSizeCheck==true) { this.showemailErrorMsg = true; flag = false; errormsg.push('Please upload the filesize less than 4MB') }
    if (!this.effectiveDate || this.effectiveDate.length <= 0) { this.showEffectivedateErrorMsg = true; flag = false; errormsg.push('Enter Effective Date') }

    
    if (flag == true) {
      if(this.isDocumentRequested==true){
        this.RequestedDocumentAddUpdateEO('EO')      
      }
else if(this.callMgaAPI==false){
      this.FileUpload();
    }
    else{
      this.documentType="EO"
      this.FileUploadMGA();
    }
    }
    else {
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')

    }
  }
  FileUpload() {
    for (var i = 0; i < this.FileDataList.length; i++) {
      this.productPhotofile = this.FileDataList[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', this.expiryDate);
        formData.append('effectiveDate', this.effectiveDate);
        formData.append('policyNumber', this.policyNumber);
        var data = this.leadId
        formData.append('leadId', data);
        //  this.fileData=formData
        if(this.documentId!=null || this.fileId!=null){
          formData.append('documentId', this.documentId)
          formData.append('fileId', this.fileId)
          }
          if(this.showCompanyDelete==true){
            formData.append('agencyId ', this.agencyId);
          }
        this.uploadImages(formData)
      }

    }
  }
  OverwriteEODoc(val){
    // console.log(val)
    this.licensRequestId==null;
    this.documentId=val.id
    this.fileenoName = val.documentName
    // this.expiryDate1 = val.expiryDate
    this.policyNumber = val.policyNumber
    this.fileId=val.fileId
    // leadId=this.leadId
    this.showCompanyDelete=false;
    this.fileenoName = "";
  }
  OverwriteEODocAgency(val){
    this.licensRequestId==null;
      
    // console.log(val)
  
    this.documentId=val.id
    this.fileenoName = "";
    this.fileId=val.fileId
    // leadId=this.leadId
    this.showCompanyDelete=true;
    this.isOverWriteEO=true
  }
  async uploadImages(formData: FormData) {
   
  //   this.loading = true;
  //   if(this.documentId==null || this.fileId==null){
  //   this.user.submitFormService(this.config.getEODocumentbroker, formData).subscribe((data: any) => {
  //     this.expiryDate = "";
  //     this.fileeno = "";
  //     this.fileenoName = "";
  //     this.policyNumber = "";
  //     this.finalDocs = data.data;
  //     this.loading = false;
  //     this.uploadEOPopup = !this.uploadEOPopup;
  //     Swal.fire('', data.message, 'success');
  //     this.showExpiry = data.data.expiryDate;
  //     this.showDocumentName = data.data.documentName;
  //     this.showPolicyNumber = data.data.policyNumber;
  //     // this.getDocument();
  //     //  this.getLeadInfo();
  //     //  this.getLeadSDocument();
  //     this.getLeadDoc();
  //     this.uploaddocs()
  //     this.openTabs(1)
  //     // this.fileId = data.data.id;
  //     // this.import();
  //   }, err => {
  //     //  this.dismiss();
  //   });
  // }
  // else{
  //   this.user.submitFormService(this.config.OverWriteEO, formData).subscribe((data: any) => {
  //     this.documentId=null ;
  //      this.fileId=null
  //     this.expiryDate = null;
  //     this.fileeno = "";
  //     this.fileenoName = "";
  //     this.policyNumber = "";
  //     this.finalDocs = data.data;
  //     this.loading = false;
  //     this.uploadEOPopup = !this.uploadEOPopup;
  //     Swal.fire('', data.message, 'success');
  //     this.showExpiry = data.data.expiryDate;
  //     this.showDocumentName = data.data.documentName;
  //     this.showPolicyNumber = data.data.policyNumber;
  //     // this.getDocument();
  //     //  this.getLeadInfo();
  //     //  this.getLeadSDocument();
  //     this.getLeadDoc();
  //     this.uploaddocs()
  //     this.openTabs(1)
  //     // this.fileId = data.data.id;
  //     // this.import();
  //   }, err => {
  //     //  this.dismiss();
  //   });
  // }
    
  if(this.showCompanyDelete==false){
    // this.loading = true;
    if(this.documentId==null){
    this.user.submitFormService(this.config.getEODocumentbroker, formData).subscribe((data: any) => {
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.uploadEOPopup = !this.uploadEOPopup;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.getDocument();
      //  this.getLeadInfo();
      //  this.getLeadSDocument();
      this.getLeadDoc();
      this.uploaddocs()
      this.openTabs(1)
      this.getLicensRequest();
      this.getEORequest();
      this.getVoidChequeRequest();  
    }, err => {
      //  this.dismiss();
    });
  }else{
    this.user.OverWriteEO(this.config.OverWriteEO, formData).subscribe((data: any) => {
      this.documentId=null ;
       this.fileId=null
      this.expiryDate = null;
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.uploadEOPopup = !this.uploadEOPopup;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.getDocument();
      //  this.getLeadInfo();
      //  this.getLeadSDocument();
      this.getLeadDoc();
      this.uploaddocs()
      this.openTabs(1)
      // this.fileId = data.data.id;
      // this.import();
    }, err => {
    });
  }
}
else{
  
  // this.loading = true;
    if(this.documentId==null){
    this.user.submitFormService(this.config.uploadEoDOcAgency, formData).subscribe((data: any) => {
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      // this.finalDocs = data.data;
      // this.loading = false;
      Swal.fire('', data.message, 'success');
      this.uploadEOPopup=false;
      // this.showExpiry = data.data.expiryDate;
      // this.showDocumentName = data.data.documentName;
      // this.showPolicyNumber = data.data.policyNumber;
      //  this.getAgencyDocuments(this.agencyId,this.leadId);
      this.openTabs22(this.agencyIndex);
      this.callAgencyDoc(this.agencyId,this.agencyIndex)
      this.getLicensRequest();
      this.getEORequest();
      this.getVoidChequeRequest();  
      // this.uploaddocs()
      // this.getLeadDoc();
      // this.fileId = data.data.id;
      // this.import();
    }, err => {
      //  this.dismiss();
    });
  }else{
    this.user.OverWriteEO(this.config.updateEoDOcAgency, formData).subscribe((data: any) => {
     
      this.expiryDate = "";
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      // this.finalDocs = data.data;
      // this.loading = false;
      this.documentId=null;
      Swal.fire('', data.message, 'success');
      this.uploadEOPopup=false;
      
      // this.showDocumentName = data.data.documentName;
      // this.showPolicyNumber = data.data.policyNumber;
      // this.getAgencyDocuments(this.agencyId,this.leadId);
      this.openTabs22(this.agencyIndex);
      this.callAgencyDoc(this.agencyId,this.agencyIndex)
      // this.uploaddocs()
      // this.getLeadDoc();
    }, err => {
    });
  }
}
  }
  uploaddocs() {
    // this.showdocuments = true;
  }
  addFieldValue() {
    this.uploadlicenseArray.push(this.newAttribute)
    this.newAttribute = {};
  }
  removelicense(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        // this.showlicense1 = false;
        this.user.deleteLicens(id).pipe()
          .subscribe(
            data => {
              if (data.success == true) {
                Swal.fire(
                  'Deleted!',
                  'Your license has been removed successfully.',
                  'success'
                )
                //this.uploadlicenseArray.splice(i, 1);
                this.getLeadDoc();
                if (this.uploadlicenseArray.length == 0) {
                  this.uploadlicenseArray.push(this.newAttribute)
                  this.newAttribute = {};
                }
              }
            }, error => {
    
              if (error.status == 400 || error.status == 417) {
                this.error = error.error.data;
              }
              else {
    
                this.error = "Something went wrong";
              }
    
            }, () => { });
       
      }
    })
   
  }
  fileExtensionLic: any;
  fileExtensionErrorLic: boolean = false;
  fileExtensionMessageLic: any;
  FileDataListLic: any;
  licfile: File=null;
  FileSelectLic(event, i) {
  
    this.licfile = event.target.files[0];
    if(this.licfile.size>4194304){
      Swal.fire({
        icon: 'error',
        text: 'Please upload the filesize less than 4MB',
      })
    }

    if (event.target.files.length > 0) {
      this.FileDataListLic = event.target.files;
      this.fileenoNameLic = this.FileDataListLic[0].name;

      try{this.fileExtensionLic = this.fileenoNameLic.split('.').pop();}catch{}
      if (this.isInArray(this.acceptedExtensions, this.fileExtensionLic)) {
        this.fileExtensionErrorLic = false;
        this.fileExtensionMessageLic = ""

        this.uploadlicenseArray[i].showemailErrorMsgone = this.fileExtensionErrorLic
        this.fileenoNameLic = this.FileDataListLic[0].name;
      } else {
        this.fileExtensionMessageLic = "Invalid file type, Please select file with allowed file types: .pdf, .png , .jpeg or .docx "
        this.fileExtensionErrorLic = true;
        this.uploadlicenseArray[i].showemailErrorMsgone = this.fileExtensionErrorLic
        this.fileenoNameLic = this.fileExtensionMessageLic

      }
      //this.uploadlicenseArray[i].showemailErrorMsgone=this.fileExtensionError;
      //this.fileenoNameLic=this.fileExtensionMessage;
    } else {
      this.uploadlicenseArray[i].showemailErrorMsgone = false;
      this.fileenoNameLic = ""
    }
  }
  FileUploadLic(uploadlic, k) {
    this.oricid=uploadlic.oricDocumentId
      if(this.FileDataListLic!=undefined){
        for (var i = 0; i < this.FileDataListLic.length; i++) {
          this.productPhotofile = this.FileDataListLic[i];
          if (this.productPhotofile != null) {
            const formData = new FormData();
            formData.append('file', this.productPhotofile);
            formData.append('expiryDate', uploadlic.expiryDateLic);
            formData.append('effectiveDate', uploadlic.effectiveDateLic);
            var data = sessionStorage.getItem('leadId');
    
            formData.append('leadId', data);
            formData.append('licencesNumber', uploadlic.licenseNumber);
            formData.append('lincencesName', this.fileenoNameLic);
    
            formData.append('licencesType', uploadlic.type);
            formData.append('province', uploadlic.provinceCode);
            if(this.fileIdlic!=null){
              formData.append('fileId', this.fileIdlic);
            }
            if(this.licenceId!=null){
              formData.append('licenceId', this.licenceId);
            }
            if(this.showCompanyDelete==true){
              formData.append('agencyId ', this.agencyId);
            }
            if(this.licensRequestId !=null ){
              formData.append('requestedId', this.licensRequestId);
            }
            if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
              formData.append('oricDocumentId', this.oricid);
            }
            this.uploadImagesLic(formData, k)
          }
        }
      }
    else{
        const formData = new FormData();
        // formData.append('file', this.productPhotofile);
        formData.append('expiryDate', uploadlic.expiryDate);
        formData.append('effectiveDate', uploadlic.effectiveDate);
        var data = sessionStorage.getItem('leadId');
        formData.append('leadId', data);
        formData.append('licencesNumber', uploadlic.licenseNumber);
        // formData.append('lincencesName', uploadlic.lincencesName);
        formData.append('licencesType', uploadlic.licencesType);
        formData.append('province', uploadlic.province);
        if(this.fileIdlic!=null || this.licenceId!=null){
        formData.append('fileId', this.fileIdlic);
        formData.append('licenceId', this.licenceId);
      }
        // this.fileData=formData
        if(this.showCompanyDelete ==true){
          formData.append('agencyId', this.agencyId);
        }
        if(this.licensRequestId !=null ){
          formData.append('requestedId', this.licensRequestId);
        }
        if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
          formData.append('oricDocumentId', this.oricid);
        }
        this.uploadImagesLic(formData, k)
      }
}

  addLic(){
    // this.fileIdlic=licval.fileId
    // this.province=licval.provinces.provinceCode
    // this.licenceId=licval.id;
    var obj={
      "expiryDateLic1":"",
      "effectiveDateLic1":"",
      "provinceCode":undefined,
      "type":undefined,
      "licenseNumber":"",
      "filelicens":"",
      "lincencesName":""
       }
      this.uploadlicenseArray=[]
      this.uploadlicenseArray.push(obj)
      this.fileIdlic=null
      // this.fileenoNameLic=licval.licenseName,
      this.licenceId=null;
      this.showCompanyDelete=false;
    }
  addLicAgency(){
    // this.fileIdlic=licval.fileId
    // this.province=licval.provinces.provinceCode
    // this.licenceId=licval.id;
    var obj={
      "expiryDateLic1":"",
      "effectiveDateLic1":"",
      "provinceCode":undefined,
      "type":undefined,
      "licenseNumber":"",
      "filelicens":"",
      "lincencesName":""
       }
      this.uploadlicenseArray=[]
      this.uploadlicenseArray.push(obj)
      this.fileIdlic=null
      // this.fileenoNameLic=licval.licenseName,
      this.licenceId=null;
      this.showCompanyDelete=true;
    }
  OverwriteLic(licval){
    // this.fileIdlic=licval.fileId
    // this.province=licval.provinces.provinceCode
    // this.licenceId=licval.id;
    this.licensRequestId==null;
    var obj={
      "expiryDateLic1":"",
      "effectiveDateLic1":"",
      "provinceCode":licval.licencesProvince,
      "type":licval.type,
      "licenseNumber":licval.licensesNumber,
      "filelicens":"",
      "lincencesName":"",
      "oricDocumentId":licval.oricDocumentId
       }
      this.uploadlicenseArray=[]
      this.uploadlicenseArray.push(obj)
      this.fileIdlic=licval.fileId
      // this.fileenoNameLic=licval.licenseName,
      this.licenceId=licval.id;
      this.showCompanyDelete=false;
      this.fileenoNameLic = "";
    }
    OverwriteLicAgency(licval){
      this.licensRequestId==null;
      var obj={
        "expiryDateLic1":"",
        "effectiveDateLic1":"",
        "provinceCode":licval.licencesProvince,
        "type":licval.type,
        "licenseNumber":licval.licensesNumber,
        "filelicens":"",
        "lincencesName":"",
        "oricDocumentId":licval.oricDocumentId
         }
        this.uploadlicenseArray=[]
        this.uploadlicenseArray.push(obj)
        this.fileIdlic=licval.fileId
        // this.fileenoNameLic=licval.licenseName,
        this.licenceId=licval.id;
        this.showCompanyDelete=true;
        this.fileenoNameLic = "";
        this.isOverWriteEO=true
    }
  
   async uploadImagesLic(formData: FormData, k) {
    if(this.showCompanyDelete==false){
      // this.loading = true;
      
      if(this.licenceId==null){
        if(this.licensRequestId != null){
          this.user.submitFormService(this.config.getLicDocumentRequested, formData).subscribe((data: any) => {
            Swal.fire('', data.message, 'success');
            this.uploadLicensePopup=false;
            this.getLeadDoc();
            this.getLicensRequest();
            this.getEORequest();
            this.getVoidChequeRequest();  
            this.licensRequestId=null;
            //  this.showlicense=true;
            this.fileenoNameLic = "";
          
          }, err => {
      
          });
        }else{
      this.user.submitFormService(this.config.getLicDocument, formData).subscribe((data: any) => {
        // this.loading = false;
        Swal.fire('', data.message, 'success');
        this.uploadLicensePopup=false;
        // this.getDocument();
        this.getLeadDoc();
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
    }else{
      this.user.submitFormService1(this.config.OverWriteLicences, formData).subscribe((data: any) => {
        // this.loading = false;
        this.licenceId=null;
         this.fileIdlic=null;
        Swal.fire('', data.message, 'success');
        // this.getDocument();
        // this.uploadLicensePopup = false;
        this.uploadLicensePopup=false;
        this.getLeadDoc();
        // this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
      }
      else{
        // this.loading = true;
      if(this.licenceId==null){
        if(this.licensRequestId != null){
          this.user.submitFormService(this.config.getLicDocumentRequested, formData).subscribe((data: any) => {
            Swal.fire('', data.message, 'success');
            this.uploadLicensePopup=false;
            this.openTabs22(this.agencyIndex);
      this.callAgencyDoc(this.agencyId,this.agencyIndex)
            this.getLicensRequest()
            this.getEORequest();
            this.getVoidChequeRequest();  
            this.licensRequestId=null;
            this.showCompanyDelete=false;
            //  this.showlicense=true;
            this.fileenoNameLic = "";
          }, err => {
      
          });
        }
        else{
      this.user.submitFormService(this.config.uploadLicensesAgency, formData).subscribe((data: any) => {
        // this.loading = false;
        Swal.fire('', data.message, 'success');
        // this.uploadLicensePopup=false;
        this.uploadLicensePopup=false;
        this.openTabs22(this.agencyIndex);
      this.callAgencyDoc(this.agencyId,this.agencyIndex)
        
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
    }else{
      this.user.submitFormService1(this.config.updateLicenes, formData).subscribe((data: any) => {
        // this.loading = false;
        this.licenceId=null;
         this.fileIdlic=null;
         this.uploadLicensePopup=false;
        Swal.fire('', data.message, 'success');
        // this.getDocument();
        // this.uploadLicensePopup = false;
        this.openTabs22(this.agencyIndex);
      this.callAgencyDoc(this.agencyId,this.agencyIndex)
        // this.showlicense=true;
        this.fileenoNameLic = "";
        // this.uploadlicenseArray.splice(k, 1);
        // this.uploadlicenseArray.push(data.data)
      }, err => {
  
      });
    }
      }

  }


  uploadlicensefile(uploadlic, i) {
    this.oricid=uploadlic.oricDocumentId
    if(this.callMgaAPI==false){
    console.log(uploadlic)
    var flag = true
    var errormsg = [];
    uploadlic.expiryDateLic = this.DatePipe.transform(uploadlic.expiryDateLic1, 'yyyy-MM-dd');
    uploadlic.effectiveDateLic = this.DatePipe.transform(uploadlic.effectiveDateLic1, 'yyyy-MM-dd');
    //if(uploadlic.showemailErrorMsgone==true){}
   // if(this.fileIdlic==null){
      if (!uploadlic.filelicens || uploadlic.filelicens.length <= 0 ) { uploadlic.showemailErrorMsgone = true; flag = false; errormsg.push('Choose File') }
   // }
    if (!uploadlic.licenseNumber || uploadlic.licenseNumber.length <= 0) { uploadlic.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
    if(!uploadlic.type || uploadlic.type.length <= 0){uploadlic.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
    if (!uploadlic.expiryDateLic || uploadlic.expiryDateLic.length <= 0) { uploadlic.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
    if (!uploadlic.provinceCode || uploadlic.provinceCode.length <= 0) { uploadlic.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
    // if(!uploadlic.licenseName || uploadlic.licenseName.length <= 0){uploadlic.showlicnameErrorMsgone=true;  flag=false; errormsg.push('Provience')} 
    if (!uploadlic.effectiveDateLic || uploadlic.effectiveDateLic.length <= 0) { uploadlic.showlicdErrorMsgEffectiveone = true; flag = false; errormsg.push('Enter Effective Date') }

    if (flag == true) {
      if(this.isDocumentRequested==true){
        this.RequestedDocumentAddUpdateLic(uploadlic, i,'LICENSES')      
      }
  else{
      this.FileUploadLic(uploadlic, i);
  }
    }
    else {
     // this.uploadLicensePopup = true;
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replace(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
    }
  }else{
    this.uploadlicensefileMGA(uploadlic, i)
  }
  }


  removeVoidcheck(id) {
    // console.log(id)
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.user.deleteVoidCheck(id).pipe()
        .subscribe(
          data => {
            if (data.success == true) {
              Swal.fire('Deleted!',
              'Your Void Cheque has been removed successfully.',
              'success');
              this.getLeadDoc();
              // this.getLeadInfo();
              // this.getLeadSDocument();
             
              // this.uploadvoidchequeArray.splice(i, 1);
            }
          }, error => {
  
            if (error.status == 400 || error.status == 417) {
              this.error = error.error.data;
            }
            else {
  
              this.error = "Something went wrong";
            }
  
          }, () => { });
      }
    })
  }
  uploadEno1(item, i) {
    if(this.LeadActivated=="Activated"){
      item.fileId=null
    }
    //
    var flag = true
    var errormsg = [];
       // banking info
       try{this.transitNo=this.transitNo.trim()}catch{}
       try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
       try{this.accountNo=this.accountNo.trim()}catch{}
       try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
       
       
      //  if(this.allowUser == true){
        
      //   if (this.btnPopupName == "Confirm"){
      //     if(this.accountNo==this.confirmaccountNo){
      //     if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;}
      //     if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;}
      //     if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false;}
      //     if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false;}
      //     if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
      //   }
      //   else{
      //     flag=false
      //   }
      //   }
      //  }else{
      //   this.bankInfoErrmsg = true;
      //   flag = false;
      //  }
      //  if(this.allowUser == true){
        if (this.btnPopupName == "Save"){
          if(this.accountNo!==this.confirmaccountNo){flag = false; errormsg.push('Account Number and Confirm Account Number does not match.');}
            if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
            if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
            if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
            if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number.')}
            if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
            // if ( this.accountConfirmFlag = false) { this.confirmAccountNumberMatch=true;flag = false;  errormsg.push('Account Number and Confirm Account Number does not match.');}
            // errormsg.push('Account Number and Confirm Account Number does not match.');
          if(item.fileId!==undefined && item.fileId!==null){
            if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
          }else{
            if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
          }
        // }else{
        //   errormsg.push('Account Number and Confirm Account Number does not match.');
        //   flag=false;
        //   // if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number')}
        //   // if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number')}
        //   // if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number')}
        //   // if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number')}
        //   // if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please check the acknowledgement checkbox.')}
        //   // errormsg.push('Account Number and Confirm Account Number does not match.');
        // }
        if(this.bankinfoChecked==true){
          this.bankInfoErrmsg=false
        }else{
          this.bankInfoErrmsg=true;
          flag = false;
        }
        }else{
          if (this.btnPopupName == "Confirm"){
            if(this.accountNo!==this.confirmaccountNo){flag = false; errormsg.push('Account Number and Confirm Account Number does not match.');}
              if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
              if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
              if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
              if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number.')}
              if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
              // if (  this.accountConfirmFlag = false) { this.confirmAccountNumberMatch=true;flag = false;  errormsg.push('Account Number and Confirm Account Number does not match.');}
            // if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
            if(item.fileId!==undefined && item.fileId!==null){
              if (!item.fileId || item.fileId.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
            }else{
              if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
            }
          // }
          // else{
          //   flag=false;
          //   errormsg.push('Account Number and Confirm Account Number does not match.');
          //     if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number.')}
          //     if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number.')}
          //     if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number.')}
          //     if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number.')}
          //     if (this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
          //     // if ( this.accountConfirmFlag = false) { this.confirmAccountNumberMatch=true;flag = false;  errormsg.push('Account Number and Confirm Account Number does not match.');}
          // }
          if(this.bankinfoChecked==true){
            this.bankInfoErrmsg=false
          }else{
            this.bankInfoErrmsg=true;
            flag = false;
          }
          
          }else{
            flag = false;
            if ( !this.bankinfoChecked) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
          }
        }
      //  }else{
      //   this.bankInfoErrmsg = true;
      //   flag = false;
      //  }
    if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
    // if(!this.expiryDate || this.expiryDate.length <= 0){this.showdateErrorMsg = true;  flag=false; errormsg.push('Date')} 

    if (flag == true) {
      if(this.isDocumentRequested==true){
        this.RequestedDocumentAddUpdateVoid(item, i,'VOID_CHEQUE')      
      }
else if(this.callMgaAPI==false){
        this.FileUpload1(item, i);
      }else{
        this.documentType="VOID_CHEQUE"
      this.FileUploadVoidMGA(item, i);
      }
    }
    else {
      if(this.bankinfoChecked==true){
        this.bankInfoErrmsg=false
      }else{
        this.bankInfoErrmsg=true;
        flag = false;
      }
      // if ( !this.confirmaccountNo || this.confirmaccountNo.length <= 0) { this.confirmaccountNoErrMsg=true; flag = false;  errormsg.push('Enter valid Confirm Account Number')}
      // if ( !this.transitNo || this.transitNo.length < 3) { this.transitNoErrMsg=true;flag = false;  errormsg.push('Enter valid 3 digits Bank Number')}
      // if ( !this.financialInstitutionNo || this.financialInstitutionNo.length < 5) { this.financialInstitutionNoErrMsg=true;flag = false; errormsg.push('Enter valid 5 digits Branch Number')}
      // if ( !this.accountNo || this.accountNo.length <= 0) { this.accountNoErrMsg=true;flag = false; errormsg.push('Enter valid Account Number')}
      // if ( this.allowUser == false) { this.bankInfoErrmsg=true;flag = false; errormsg.push('Please click the acknowledgement checkbox.')}
      this.msg = errormsg.toString();
      this.msgfinal = this.msg.replaceAll(",", '<br />');
      Swal.fire("", "Please complete the following mandatory field(s):"  +","+"<br>" + this.msgfinal, 'warning')

    }
  
    
  }
  FileUpload1(item, k) {
    //
    if(this.allowUser == true){
      if(this.btnPopupName == "Save"){
        //
        for (var i = 0; i < this.FileDataList1.length; i++) {
          this.productPhotofile1 = this.FileDataList1[i];
          if (this.productPhotofile1 != null) {
            const formData = new FormData();
            formData.append('file', this.productPhotofile1);
            formData.append('accountNumber', this.accountNo);
            formData.append('confirmaccountNo', this.confirmaccountNo);
            formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
            formData.append('transitNumber', this.transitNo);
            var data = sessionStorage.getItem('leadId')
            formData.append('leadId', data);
            //  this.fileData=formData
            if(this.fileIdvoid!=null || this.voidchequeId!=null){
              formData.append('fileId', this.fileIdvoid);
              formData.append('voidChequeId', this.voidchequeId);
            }
            if(this.showCompanyDelete==true){
             formData.append('agencyId ', this.agencyId);
           }
            this.uploadImages1(formData, k)
          }
        }
      }

      if(this.btnPopupName == "Confirm"){
        //
        if(this.FileDataList1!=undefined){
          this.productPhotofile1 = this.FileDataList1[0];
        }
            const formData = new FormData();
            formData.append('accountNumber', this.accountNo);
            formData.append('confirmaccountNo', this.confirmaccountNo);
            formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
            formData.append('transitNumber', this.transitNo);
            var data = sessionStorage.getItem('leadId')
            formData.append('leadId', data);
            //  this.fileData=formData
            if(this.fileIdvoid!=null || this.voidchequeId!=null){
              formData.append('fileId', this.fileIdvoid);
              formData.append('voidChequeId', this.voidchequeId);
            }
            if(this.showCompanyDelete==true){
             formData.append('agencyId ', this.agencyId);
           }
           if(this.productPhotofile1!=undefined){
            formData.append('file', this.productPhotofile1);
          }
            this.uploadImages1(formData, k)
          
      }
      }else{
        if(this.FileDataList1!=undefined){
        for (var i = 0; i < this.FileDataList1.length; i++) {
          this.productPhotofile1 = this.FileDataList1[i];
          if (this.productPhotofile1 != null) {
            const formData = new FormData();
            formData.append('file', this.productPhotofile1);
            formData.append('accountNumber', this.accountNo);
            formData.append('confirmaccountNo', this.confirmaccountNo);
            formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
            formData.append('transitNumber', this.transitNo);
            var data = sessionStorage.getItem('leadId')
            formData.append('leadId', data);
            //  this.fileData=formData
            if(this.fileIdvoid!=null || this.voidchequeId!=null){
              formData.append('fileId', this.fileIdvoid);
              formData.append('voidChequeId', this.voidchequeId);
            }
            if(this.showCompanyDelete==true){
             formData.append('agencyId ', this.agencyId);
           }
            this.uploadImages1(formData, k)
          }
        }
      }
      // }
    
  }
      // if(this.allowUser == true){
      //     const formData = new FormData();
      //     formData.append('file', this.productPhotofile1);
      //     formData.append('accountNumber', this.accountNo);
      //     formData.append('confirmaccountNo', this.confirmaccountNo);
      //     formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      //     formData.append('transitNumber', this.transitNo);
      //     var data = this.leadId
      //     formData.append('leadId', data);
      //     //  this.fileData=formData
      //     if(this.fileIdvoid!=null || this.voidchequeId!=null){
      //       formData.append('fileId', this.fileIdvoid);
      //       formData.append('voidChequeId', this.voidchequeId);
      //     }
      //     if(this.showCompanyDelete==true){
      //      formData.append('agencyId ', this.agencyId);
      //    }
      //     this.uploadImages1(formData, k)
      //   }else{
      //     if(this.FileDataList1!=undefined){
      //       for (var i = 0; i < this.FileDataList1.length; i++) {
      //         this.productPhotofile1 = this.FileDataList1[i];
      //         if (this.productPhotofile1 != null) {
      //         const formData = new FormData();
      //         formData.append('file', this.productPhotofile1);
      //         formData.append('accountNumber', this.accountNo);
      //         formData.append('confirmaccountNo', this.confirmaccountNo);
      //         formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      //         formData.append('transitNumber', this.transitNo);
      //         var data = this.leadId
      //         formData.append('leadId', data);
      //         //  this.fileData=formData
      //         if(this.fileIdvoid!=null || this.voidchequeId!=null){
      //           formData.append('fileId', this.fileIdvoid);
      //           formData.append('voidChequeId', this.voidchequeId);
      //         }
      //         if(this.showCompanyDelete==true){
      //          formData.append('agencyId ', this.agencyId);
      //        }
      //         this.uploadImages1(formData, k)
      //       }
      //     }
      //   }
      // }
    //   else{
    //   for (var i = 0; i < this.FileDataList1.length; i++) {
    //     this.productPhotofile1 = this.FileDataList1[i];
    //     if (this.productPhotofile1 != null) {
    //       const formData = new FormData();
    //       formData.append('accountNumber', this.accountNo);
    //       formData.append('confirmaccountNo', this.confirmaccountNo);
    //       formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
    //       formData.append('transitNumber', this.transitNo);
    //       formData.append('file', this.productPhotofile1);
    //       var data = this.leadId
    //       formData.append('leadId', data);
    //       if(this.fileIdvoid!=null || this.voidchequeId!=null){
    //         formData.append('fileId', this.fileIdvoid);
    //         formData.append('voidChequeId', this.voidchequeId);
    //       }
    //       if(this.showCompanyDelete==true){
    //         formData.append('agencyId ', this.agencyId);
    //       }
    //       this.uploadImages1(formData, k)
    //     }
  
    //   }
    // }
  
  }
  overwriteVoid(voidval){
    //
    this.fileIdvoid=voidval.fileId;
this.voidchequeId=voidval.id;
this.isOverWriteEO=true
    var obj={
      "fileeno1":voidval.fileUrl,
       }
      this.uploadvoidchequeArray=[]
      this.uploadvoidchequeArray.push(voidval)
       this.fileenoName1=voidval.documentName
  }
  // banking info
  uploadEno1Void(item,i){
    //
    if(this.LeadActivated=="Activated"){
      
      this.voidIndexitem=[]
    }
    else{
      this.voidIndexitem=item;
    }
   
    this.indexno=i;
    this.isOverWriteEO=true
  }
  async uploadImages1(formData: FormData, k) {
    this.loading = true;
    
    if(this.showCompanyDelete==false){
    if(this.fileIdvoid==null || this.voidchequeId==null){
    this.user.submitFormService(this.config.uploadVoidChequebroker, formData).subscribe((data: any) => {

      this.finalDocs1 = data.data;
      this.loading = false;
      this.uploadVoidChequePopup = !this.uploadVoidChequePopup;
      Swal.fire('', data.message, 'success');
      // this.getDocument();
      this.getLeadDoc();
      this.getLicensRequest();
      this.getEORequest();
      this.getVoidChequeRequest();  
      this.openTabs(1)
      this.showDocumentName1 = data.data.documentName;
      this.fileenoName1 = ""
      this.uploadvoidchequeArray.splice(k, 1);
      this.uploadvoidchequeArray.push(data.data)

    }, err => {

    });
  }
  else{
    this.user.submitFormService(this.config.OverWriteVoidCheque, formData).subscribe((data: any) => {
      this.fileIdvoid=null; 
      this.voidchequeId=null;
      this.finalDocs1 = data.data;
      this.loading = false;
      this.BankInfo = false;
      this.uploadVoidChequePopup = false;
      Swal.fire('', data.message, 'success');
      // this.getDocument();
      this.getLeadDoc();
      this.openTabs(1)
      this.getLicensRequest();
      this.getEORequest();
      this.getVoidChequeRequest();  
      this.showDocumentName1 = data.data.documentName;
      this.fileenoName1 = ""
      this.uploadvoidchequeArray.splice(k, 1);
      this.uploadvoidchequeArray.push(data.data)

    }, err => {

    });
  }
    }else{
      if(this.fileIdvoid==null || this.voidchequeId==null){
        this.user.submitFormService(this.config.uploadVoidAgency, formData).subscribe((data: any) => {
    
          this.finalDocs1 = data.data;
          this.loading = false;
          this.uploadVoidChequePopup = !this.uploadVoidChequePopup;
          Swal.fire('', data.message, 'success');
          // this.getDocument();
          this.openTabs22(this.agencyIndex);
      this.callAgencyDoc(this.agencyId,this.agencyIndex)
          this.getLicensRequest();
          this.getEORequest();
          this.getVoidChequeRequest();  
          this.showDocumentName1 = data.data.documentName;
          this.fileenoName1 = ""
          this.uploadvoidchequeArray.splice(k, 1);
          this.uploadvoidchequeArray.push(data.data)
    
        }, err => {
    
        });
      }
      else{
        this.user.submitFormService(this.config.updateVoidAgency, formData).subscribe((data: any) => {
          this.fileIdvoid=null; 
          this.voidchequeId=null;
          this.finalDocs1 = data.data;
          this.loading = false;
          this.BankInfo = false;
          this.uploadVoidChequePopup = false;
          Swal.fire('', data.message, 'success');
          // this.getDocument();
          this.openTabs22(this.agencyIndex);
      this.callAgencyDoc(this.agencyId,this.agencyIndex)
          this.getLicensRequest();
          this.getEORequest();
          this.getVoidChequeRequest();  
          this.showDocumentName1 = data.data.documentName;
          this.fileenoName1 = ""
          this.uploadvoidchequeArray.splice(k, 1);
          this.uploadvoidchequeArray.push(data.data)
    
        }, err => {
    
        });
      }
    }
  }

  eoPopUrl: any;
  eoName: any;
  onClickEo(url,name,fileId){
      
// this.eoPopUrl = url;
this.user.getLeadPreviewLink(fileId).pipe()
.subscribe(
    data => {
        
    //  console.log(data.data)
     this.eoPopUrl=data.data
 
    },error=>{
   
        if(error.status == 400 || error.status==417){
            this.error=error.error.data;
           
         }
         else{
           
           this.error="Something went wrong.";
         }
    
        },()=>{});
this.eoName = name
setTimeout(() => 
{
  this.pdfmodel = !this.pdfmodel;
 
},
2000);
  }

  licensesUrl: any;
  liname: any;
  onClickLicences(url,name,fileId){
    // this.licensesUrl = url;
    this.user.getLeadPreviewLink(fileId).pipe()
.subscribe(
    data => {
        
    //  console.log(data.data)
     this.licensesUrl=data.data
 
    },error=>{
   
        if(error.status == 400 || error.status==417){
            this.error=error.error.data;
           
         }
         else{
           
           this.error="Something went wrong.";
         }
    
        },()=>{});
    this.liname=name;
    setTimeout(() => 
    {
      this.pdfmodel1 = !this.pdfmodel1;
    },
    2000);
      }

  voidCheckUrl: any;
  vname: any;
  onVoidCheck(url, name,fileId){
        // this.voidCheckUrl = url;
        this.user.getLeadPreviewLink(fileId).pipe()
    .subscribe(
    data => {
        
    //  console.log(data.data)
     this.voidCheckUrl=data.data
 
    },error=>{
   
        if(error.status == 400 || error.status==417){
            this.error=error.error.data;
           
         }
         else{
           
           this.error="Something went wrong.";
         }
    
        },()=>{});
        this.vname = name
        setTimeout(() => 
        {
          this.pdfmodel2 = !this.pdfmodel2;
        },
        2000);
          }
          getMisc:[];
          pdfmodelMisc:boolean=false;
          UrlMisc:any
          miscPreview:any;
          selectedFileName:any;
          miscDownloadID:any=null;
          getMiscDocument(){
            //debugger
            this.user.getMiscDocument(this.leadId).pipe()
          .subscribe(
              data => {
                  this.getMisc = data.data;
                  this.urlSafe = data.data[0].embeddedSigningUrl;
              },error=>{
                  },()=>{});
          }
          onPreviewMisc(url,fileIdMisc) {
            //debugger
            // this.licensPreview = url;
            if(fileIdMisc ==null){
              this.urlSafe = url;
              this.iframemodel = !this.iframemodel;
              // this.pdfmodelMisc = false
              // this.getMiscDocument();
            }
            this.miscDownloadID=fileIdMisc
            this.user.getLeadPreviewLink(fileIdMisc).pipe()
            .subscribe(
                data => {
                    
                 this.UrlMisc=data.data
                 this.getMiscDocument();
                },error=>{
               
                    if(error.status == 400 || error.status==417){
                        this.error=error.error.data;
                       
                     }
                     else{
                       
                       this.error="Something went wrong.";
                     }
                
                    },()=>{});
                    this.selectedFileName = name;
              //this.docId = id;
            setTimeout(() => 
            {
              this.pdfmodelMisc = !this.pdfmodelMisc;
            },
            2500);
            // this.licensPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url)
        
          }
          callAgencyDoc(id,index){
            this.agencyId=id
            this.agencyIndex=index
            this.getLicensRequest();
            this.getEORequest();
            this.getVoidChequeRequest();  
            this.getLeadSDocumentAgency(this.agencyId,this.leadId);
            this.openTabs22(this.agencyIndex);
            this.showCompanyDelete=true;
            this.callMgaAPI=false
          }
          callIndividualDoc(){
          this.getLeadDoc();
          this.showCompanyDelete=false;
          this.callMgaAPI=false
          }
          agencyId:any;
          getLeadSDocumentAgency(agencyId,leadId){
            this.user.getAgencydocuments(agencyId,leadId).pipe()
          .subscribe(
              data => {
                this.getDocuments=[];
                this.getLicences=[];
                this.getVoidCheck=[];
                this.getLicences1=[];
                if(data.data.accountDetails.length!=0){
                  this.transitNo = data.data.accountDetails[0]?.transitNumber;
                  this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
                  this.accountNo = data.data.accountDetails[0]?.accountNumber;
                  this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
                  this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
                  this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
                }
                else{
                  this.transitNo =null;
                  this.financialInstitutionNo=null;
                  this.accountNo=null;
                  this.confirmaccountNo =null;
                  this.maskaccountNo =null;
                  this.eyeIconShowAccountNumber =null;
                }
                if(data.data.documents != null){
                  this.getDocuments.push(data.data.documents);
                }
                if(data.data.licences != null){
                  this.getLicences = data.data.licences;
                }
                if (this.type == 'Travel Agent') {
                  this.getLicences = this.getLicences.filter(licence => {
                      // Check the provinceCode for each licence and remove if it's not 'NS'
                      return licence.provinces.provinceCode === 'NS';
                  });
              }
                if (data.data.licences.length != 0) {
                 
                  for (var i = 0; i < data.data.licences.length; i++) {
                    var obj = {}
                    //this.uploadlicenseArray.push(data.data.licences[i]);
                    try{obj["urltreamlic"] = data.data.licences[i].fileDownloadUrl.split('.').pop();}catch{}
                    obj["createdAt"] = data.data.licences[i].createdAt;
                    obj["createdBy"] = data.data.licences[i].createdBy;
                    obj["description"] = data.data.licences[i].description;
                    obj["expiryDate"] = data.data.licences[i].expiryDate;
                    obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
                    obj["fileId"] = data.data.licences[i].fileId;
                    obj["fileUrl"] = data.data.licences[i].fileUrl;
                    obj["id"] = data.data.licences[i].id;
                    obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
                    obj["licencesProvince"] = data.data.licences[i].licencesProvince;
                    obj["licencesType"] = data.data.licences[i].licencesType;
                    obj["licenseName"] = data.data.licences[i].licenseName;
                    obj["licensesNumber"] = data.data.licences[i].licensesNumber;
                    obj["status"] = data.data.licences[i].status;
                    obj["type"] = data.data.licences[i].type;
                    obj["updatedAt"] = data.data.licences[i].updatedAt;
                    obj["provinceName"] = data.data.licences[i].provinces.provinceName;
                    obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
                    obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
                    obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
                   
                    this.uploadlicenseArray.push(obj)
                  }
                  
                 
                }
                this.showCompany=true;
                
                // if(data.data.accountDetails != null){
                //   this.getVoidCheck = data.data.accountDetails;
                // }
                 if(data.data.accountDetails.length>0){
          data.data.accountDetails.forEach((voidChequeaccountDetails: any) => {
            this.getVoidCheck.push(voidChequeaccountDetails);
          });
        }
              },error=>{
                  },()=>{});
          }
  uploadnewLicensePopup:boolean=false;
  uploadExpEOPopup:boolean=false;
  onClickaddnewLicUpload(){
    this.uploadnewLicensePopup=false;
      Swal.fire("", "License successfully summited", 'success')
    }
    downloadMiscFile(){
      this.user.downloadFile(this.miscDownloadID).pipe()
      .subscribe(
          data => {
            var miscFileName
            miscFileName = data.data.split('downloadFile/').pop();
            saveAs(data.data,miscFileName)
          },error=>{
              },()=>{});
    }
    requestLicensarray=[]
getLicensRequest(){
    this.user.getLicenseRequestCall(this.leadId,'LINCENCES').pipe()
  .subscribe(
      data => {
        if(data.status==true){
        this.requestLicensarray=[]
        this.requestLicensarray=data.data
        this.LicReqRedDot=true
        }else{
          this.LicReqRedDot=false
        this.requestLicensarray=[]
        }
      },error=>{
          },()=>{});
  }
  
  licensRequestId: any;
  clickOnRequest(id){
    this.licenceId=null;
    var obj={
      "expiryDateLic1":"",
      "effectiveDateLic1":"",
      "provinceCode":undefined,
      "type":undefined,
      "licenseNumber":"",
      "filelicens":"",
      "lincencesName":""
       }
      this.uploadlicenseArray=[]
      this.uploadlicenseArray.push(obj)
   this.licensRequestId=id;
  //  this.uploadnewLicensePopup = true;
  //  this.uploadLicensePopup = !this.uploadLicensePopup;
   this.showLicTypeonPopup=this.individualLicType;
  }
  clickOnRequestAgency(id){
    this.licenceId=null;
    this.licensRequestId=id;
    var obj={
      "expiryDateLic1":"",
      "effectiveDateLic1":"",
      "provinceCode":undefined,
      "type":undefined,
      "licenseNumber":"",
      "filelicens":"",
      "lincencesName":""
       }
      this.uploadlicenseArray=[]
      this.uploadlicenseArray.push(obj)
  //  this.uploadnewLicensePopup = true;
  // this.uploadLicensePopup = !this.uploadLicensePopup;
   this.showCompanyDelete=true;
   this.showLicTypeonPopup=this.corporateLicType;
  }
  otpVerificationPopup:boolean=false;
  otpOfVoidCheque:any;
  documentIdForOTPVerificationData:any=null;
  // onClickOTPValidation(item){
  //     this.otpOfVoidCheque=null;
  //     this.documentIdForOTPVerificationData=item;
  //     const request = {
  //       "documentId": this.documentIdForOTPVerificationData?.id,
  //       "otp": ""
  //     }    
  //     this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
  //       
  //       if(data.status==true){
  //         this.onVoidCheck(this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.fileId)
  //       }else{
  //         this.otpVerificationPopup=true;
  //         this.sendOtpForVoidCheque();
  //       }
  //       },error=>{{
  //       }},()=>{});
     
  // }
  linkAgnecyCodeAgentData=[];
  linkAgnecyCodeAgentData1=[];
  getAgentCode(){
    
          this.user.getLeadAgentsCodes(this.leadId).pipe()
        .subscribe(
            data => {
              
              this.linkAgnecyCodeAgentData=[];
              this.linkAgnecyCodeAgentData1=[];
              for(let i=0; i<data.data.agentCodes.length; i++){
                
                try{
                  this.leadId=data.data.agentCodes[i].leadId
                 
                }
                catch{
  
                }
                
               // this.partnerfirstname=data.data.agentCodes[0].leadFirstName
               // this.partnerlastname=data.data.agentCodes[0].leadLastName
                if (data.data.agentCodes[i].agentCode.toLowerCase().indexOf('ovr') > -1){
                }else{
                  if(data.data.agentCodes[i].status=='Primary' || data.data.agentCodes[i].status=='Active'){
                    this.linkAgnecyCodeAgentData1.push({"id":data.data.agentCodes[i].id,"agentCode":data.data.agentCodes[i].agentCode,"agentId":data.data.agentCodes[i].agentId});
                  }
                  // if(data.data.agentCodes[i].status=='Primary' || data.data.agentCodes[i].status=='Active'){
                    this.linkAgnecyCodeAgentData.push({"id":data.data.agentCodes[i].id,"agentCode":data.data.agentCodes[i].agentCode,"agentId":data.data.agentCodes[i].agentId});
                  // }
                }  
              }
            },error=>{
                },()=>{});
        }
   
  // sendOtpForVoidCheque(){
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": ""
  //   }    
  //   this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
  //     if(data.status==true){
  //       this.toastr.success("Verification Code sent successfully.");
  //     }else{
  //       this.toastr.error(data.message);
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  // verifyOTP(){
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": this.otpOfVoidCheque
  //   }    
  //   this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
  //   if(data.status==true){
  //       this.otpVerificationPopup=false;
  //       this.onVoidCheck(this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.fileId)
  //     }else{
  //       this.toastr.success("Incorrect Verification Code");
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  // resendVoidChequeOTP(){
  //   this.otpOfVoidCheque=null;
  //   this.otpVerificationPopup=true;
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": ""
  //   }    
  //   this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
  //     if(data.status==true){
  //       this.toastr.success("Verification Code sent successfully.");
  //     }else{
  //       this.toastr.error(data.message);
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  editBankInfo(){
    
    this.EditBankInfo = false;
    // this.BankInfo = true;
    this.popupName="Update"
    this.btnPopupName ="Save"
    this.btncancelPopupName ="Cancel"
  }

  voidStatus : any;
   bankInfoPop(){
    if(this.LeadActivated=="Activated"){
      this.transitNo = null;
      this.financialInstitutionNo = null;
      this.confirmaccountNo = null;
      this.accountNo = null;
      this.fileId = null;
      this.fileenoName1 = null;
      this.confirmAccountNumberMatch = false;
      this.bankinfoChecked = false;
      this.bankInfoErrmsg=false
    }else{
      this.fileenoName1 = null;
      this.bankinfoChecked = false;
      this.transitNm = this.transitNo;
      this.financialInstNumber = this.financialInstitutionNo;
      this.accNm = this.accountNo;
      this.confirmaccountNo = this.accountNo;
      this.bankInfoErrmsg=false
    }
  }
  closeBankInfoPopup(){
    //
    this.BankInfo = false;
    this.bankName = this.bankNm;
    this.transitNo = this.transitNm;
    this.financialInstitutionNo = this.financialInstNumber;
    this.accountNo = this.accNm;
    this.confirmaccountNo = this.accNm;
  }
  confirmaccountNoErrMsgred(){
    try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
    if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}}
  transitNoErrMsgred(){
    try{this.transitNo=this.transitNo.trim()}catch{}
    if(!this.transitNo){this.transitNoErrMsg = true} else{this.transitNoErrMsg = false}}
  financialInstitutionNoErrMsgred(){
    try{this.financialInstitutionNo=this.financialInstitutionNo.trim()}catch{}
    if(!this.financialInstitutionNo){this.financialInstitutionNoErrMsg = true} else{this.financialInstitutionNoErrMsg = false}}
  accountNoErrMsgred(){
    //
    try{this.accountNo=this.accountNo.trim()}catch{}
    if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
  }
   // payment module
   openHistoryTabs(index){
    
    if (this.searchName != undefined && this.searchName!=="" && this.searchName!==null) { 
      this.searchString = this.searchName;
    } else {
      this.searchString = "All";
    }
    this.reset();
    this.tabs[index].active = 'active';
    this.tabs[index].tabcontent = 'tabcontent';
    this.getPaymentHsry=[];
    this.user.getPaymentHistory(this.leadId,this.searchString,this.sortBy,this.sortDir,this.page,this.size).pipe()
    .subscribe(
      data => {
        console.log(data);
        this.getPaymentHsry = data.data?.paymentHistoryResponses;
        this.historyTotal = data.data.total;
        this.paymentTabRedDot = data.data?.newRecords;
      }, error => {
      }, () => { });
  }
  pageChnageDone(data){
    this.page = data-1;
    if(this.ascSortApplied==true){
      this.onSortdata(this.sortBy);
      return;
    }
    else if(this.descSortApplied==true){
      this.onSortdescdata(this.sortBy);
      return;
    } else {
       this.openHistoryTabs(3);
    } 
  }
  onSortdata(data){
    
    this.sortDir = 'asc';
    this.sortBy = data;
    // sessionStorage.setItem('sortDir',this.sortDir);
    // sessionStorage.setItem('sortBy',this.sortBy);
    this.openHistoryTabs(3);
  }
  onSortdescdata(data){
    
    this.sortDir = 'desc';
    this.sortBy = data;
    // sessionStorage.setItem('sortDir',this.sortDir);
    // sessionStorage.setItem('sortBy',this.sortBy);
    this.openHistoryTabs(3);
  }
  //  Search string by email first name, last name 
  onSearchString(searchString){
    
    this.searchName = searchString;
     if(searchString.length>1){
      setTimeout(() => {
      if(searchString.length==this.searchName.length){
      setTimeout(() => {
        this.openHistoryTabs(3);
        
    },
      500);
      } 
    },
    1500);
    }
    if(searchString.length<1){
      
      this.searchString = null;
      this.openHistoryTabs(3);
    } 
    }
  confirmAccountNumberMatch: boolean=false;
  accountConfirmFlag:boolean=false;
  checkConfirmAccountNumber(){
    try{this.confirmaccountNo=this.confirmaccountNo.trim()}catch{}
    if(!this.confirmaccountNo){this.confirmaccountNoErrMsg = true} else{this.confirmaccountNoErrMsg = false}
    
    if(this.accountNo && this.confirmaccountNo){
      if(this.accountNo==this.confirmaccountNo){
        this.confirmAccountNumberMatch = false;
        this.accountConfirmFlag = false;
      }else{
        this.confirmAccountNumberMatch = true;
        this.accountConfirmFlag = false;
      }
    }
    
  }
  checkAccountNumber(){
    try{this.accountNo=this.accountNo.trim()}catch{}
    if(!this.accountNo){this.accountNoErrMsg = true} else{this.accountNoErrMsg = false}
    
    if(this.accountNo && this.confirmaccountNo){
      if(this.accountNo==this.confirmaccountNo){
        this.confirmAccountNumberMatch = false;
        this.accountConfirmFlag = false;
        // this.allowUser=true
      }else{
        this.confirmAccountNumberMatch = true;
        this.accountConfirmFlag = false;
        // this.allowUser=false
      }
    }
    
  }
 
  bankinfoChecked: boolean=false;
  bankInfoErrmsg: boolean=false;
  allowUser: boolean=false;
  onBankInfoSelected(data){
    
    var checkFlag = data.target.checked;
    if(checkFlag == true){
      this.allowUser = true;
      this.bankInfoErrmsg = false;
      this.bankinfoChecked=true;
    }
    else{
      this.bankInfoErrmsg = true;
      this.allowUser = false;
      this.bankinfoChecked=false;
    }
  }
  cancelBtnPopup(){
    this.uploadVoidChequePopup = false;
    this.bankInfoErrmsg = false;
    this.bankName = this.bankNm;
    this.transitNo = this.transitNm;
    this.financialInstitutionNo = this.financialInstNumber;
    this.accountNo = this.accNm;
    this.confirmaccountNo = this.accNm;
  }
updateMgaShortName(){
  const request={
    "id": this.mgaId,
    "mgaShortName": this.mgaName,
  }
  // updateVoidChequeotpVerificationPopup:boolean=false;
  // otpVerificationPopup:boolean=false;
  // otpOfVoidCheque:any;
  // documentIdForOTPVerificationData:any=null;
  // onClickOTPValidation1(item){
  //   if(item.status=='Approved'){
  //   this.otpOfVoidCheque=null;
  //   this.documentIdForOTPVerificationData=item;
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": ""
  //   }    
  //   this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
  //     // if(data.status==true){
  //     //   this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
  //     // }else{
  //       this.updateVoidChequeotpVerificationPopup=true;
  //       this.sendOtpForVoidCheque1();
  //     // }
  //   },error=>{{
  //   }},()=>{});
  // }else{
  //   this.uploadVoidChequePopup = true;
  // }
  // }
  // sendOtpForVoidCheque1(){
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": ""
  //   }    
  //   this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
  //     if(data.status==true){
  //       this.toastr.success("Verification Code sent successfully.");
  //     }else{
  //       this.toastr.error(data.message);
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  // verifyOTP1(){
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": this.otpOfVoidCheque
  //   }    
  //   this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
  //   if(data.status==true){
  //       this.uploadVoidChequePopup=true;
  //       this.updateVoidChequeotpVerificationPopup = false;
  //       // this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
  //     }else{
  //       this.toastr.success("Incorrect Verification Code");
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  // resendVoidChequeOTP1(){
  //   this.otpOfVoidCheque=null;
  //   this.updateVoidChequeotpVerificationPopup=true;
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": ""
  //   }    
  //   this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
  //     if(data.status==true){
  //       this.toastr.success("Verification Code sent successfully.");
  //     }else{
  //       this.toastr.error(data.message);
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  this.user.submitFormService(this.config.updateMGAShortName, request).subscribe((data: any) => {
    this.editMGAShortName=false
    this.mgaName = data.data?.mgaShortName;
  }, err => {
  });
}
eyeIconShowAccountNumber: boolean =false;
eyeIcon: boolean=false;
maskaccountNo: any;
showAccountNumber(a) {
  
  this.eyeIcon=!this.eyeIcon
  if (this.eyeIcon == true){
    if(a=='Confirm'){
      this.confirmaccountNo  = this.eyeIconShowAccountNumber;
    }
    if(a=='Account'){
      this.accountNo  = this.eyeIconShowAccountNumber;
    }  
  }else{
    if(a=='Confirm'){
      this.confirmaccountNo = this.maskaccountNo;
    }
    if(a=='Account'){
      this.accountNo  = this.maskaccountNo;
    this.uploadVoidChequePopup = true;
  }
  }
  // sendOtpForVoidCheque1(){
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": ""
  //   }    
  //   this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
  //     if(data.status==true){
  //       this.toastr.success("Verification Code sent successfully.");
  //     }else{
  //       this.toastr.error(data.message);
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  // verifyOTP1(){
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": this.otpOfVoidCheque
  //   }    
  //   this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
  //   if(data.status==true){
  //       this.uploadVoidChequePopup=true;
  //       this.updateVoidChequeotpVerificationPopup = false;
  //       // this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
  //     }else{
  //       this.toastr.error("Incorrect Verification Code");
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  // resendVoidChequeOTP1(){
  //   this.otpOfVoidCheque=null;
  //   this.updateVoidChequeotpVerificationPopup=true;
  //   const request = {
  //     "documentId": this.documentIdForOTPVerificationData?.id,
  //     "otp": ""
  //   }    
  //   this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
  //     if(data.status==true){
  //       this.toastr.success("Verification Code sent successfully.");
  //     }else{
  //       this.toastr.error(data.message);
  //     }
  //   },error=>{{
  //   }},()=>{});
  // }
  // eyeIconShowAccountNumber: boolean =false;
  // eyeIcon: boolean=false;
  // maskaccountNo: any;
  // showAccountNumber(a) {
  //   
  //   this.eyeIcon=!this.eyeIcon
  //   if (this.eyeIcon == true){
  //     if(a=='Confirm'){
  //       this.confirmaccountNo  = this.eyeIconShowAccountNumber;
  //     }
  //     if(a=='Account'){
  //       this.accountNo  = this.eyeIconShowAccountNumber;
  //     }  
  //   }else{
  //     if(a=='Confirm'){
  //       this.confirmaccountNo = this.maskaccountNo;
  //     }
  //     if(a=='Account'){
  //       this.accountNo  = this.maskaccountNo;
  //     }
  //   }
  // }
}
updateBtnPopupName(){
  this.btnPopupName = "Confirm";
}
changeMGAShortName(){
  this.editMGAShortName =! this.editMGAShortName;
}


callMgaDoc(selectedmgaId,index){
  this.mgaIndex=index
     this.mgaId=selectedmgaId
  this.getMGADocuments(this.mgaId,this.mgaIndex);
  this.openTabs21(this.mgaIndex);
  this.callMgaAPI=true
}
getMGADocuments(MGAid,index){
    
    this.user.getMGAdocument(MGAid,this.leadId).pipe()
    .subscribe(
      data => {
        this.getDocuments=[];
        this.getLicences=[];
        this.getVoidCheck=[];
        this.getLicences1=[];
        if(data.data.documents != null){
          this.getDocuments.push(data.data.documents);
        }
        if(data.data.licences != null){
          this.getLicences = data.data.licences;
        }
        if (this.type == 'Travel Agent') {
          this.getLicences = this.getLicences.filter(licence => {
              // Check the provinceCode for each licence and remove if it's not 'NS'
              return licence.provinces.provinceCode === 'NS';
          });
      }
        if (data.data.licences.length != 0) {
         
          for (var i = 0; i < data.data.licences.length; i++) {
            var obj = {}
            //this.uploadlicenseArray.push(data.data.licences[i]);
            try{obj["urltreamlic"] = data.data.licences[i].fileDownloadUrl.split('.').pop();}catch{}
            obj["createdAt"] = data.data.licences[i].createdAt;
            obj["createdBy"] = data.data.licences[i].createdBy;
            obj["description"] = data.data.licences[i].description;
            obj["expiryDate"] = data.data.licences[i].expiryDate;
            obj["fileDownloadUrl"] = data.data.licences[i].fileDownloadUrl;
            obj["fileId"] = data.data.licences[i].fileId;
            obj["fileUrl"] = data.data.licences[i].fileUrl;
            obj["id"] = data.data.licences[i].id;
            obj["lastModifiedBy"] = data.data.licences[i].lastModifiedBy;
            obj["licencesProvince"] = data.data.licences[i].licencesProvince;
            obj["licencesType"] = data.data.licences[i].licencesType;
            obj["licenseName"] = data.data.licences[i].licenseName;
            obj["licensesNumber"] = data.data.licences[i].licensesNumber;
            obj["status"] = data.data.licences[i].status;
            obj["type"] = data.data.licences[i].type;
            obj["updatedAt"] = data.data.licences[i].updatedAt;
            obj["provinceName"] = data.data.licences[i].provinces.provinceName;
            obj["provinceCode"] = data.data.licences[i].provinces.provinceCode;
            obj["isFirstTimeUpload"] = data.data.licences[i].isFirstTimeUpload;
            obj["isEditableDocument"] = data.data.licences[i].isEditableDocument;
           
            this.uploadlicenseArray.push(obj)
          }
          
         
        }
        this.showCompany=true;
        if(data.data.accountDetails.length!=0){
          this.transitNo = data.data.accountDetails[0]?.transitNumber;
          this.financialInstitutionNo = data.data.accountDetails[0]?.finacialInstitutionNumber;
          this.accountNo = data.data.accountDetails[0]?.accountNumber;
          this.confirmaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.maskaccountNo = data.data.accountDetails[0]?.accountNumber;
          this.eyeIconShowAccountNumber = data.data.accountDetails[0]?.accountNumberPlain;
        }
        else{
          this.transitNo =null;
          this.financialInstitutionNo=null;
          this.accountNo=null;
          this.confirmaccountNo =null;
          this.maskaccountNo =null;
          this.eyeIconShowAccountNumber =null;
        }
        // if(data.data.accountDetails != null){
        //   this.getVoidCheck = data.data.accountDetails;
        // }
         if(data.data.accountDetails.length>0){
          data.data.accountDetails.forEach((voidChequeaccountDetails: any) => {
            this.getVoidCheck.push(voidChequeaccountDetails);
          });
        }
      },error=>{
          },()=>{});
  }
  FileUploadMGA() {
    if(this.FileDataList!=undefined){
    for (var i = 0; i < this.FileDataList.length; i++) {
      this.productPhotofile = this.FileDataList[i];
      if (this.productPhotofile != null) {
        const formData = new FormData();
        formData.append('file', this.productPhotofile);
        formData.append('expiryDate', this.expiryDate);
        formData.append('effectiveDate', this.effectiveDate);
        formData.append('leadId', this.leadId);
        // formData.append('agencyId',this.agencyId)
        formData.append('DocNumber',this.policyNumber)
        // formData.append('accountNumber',this.agencyId)
        // formData.append('bankNumber',this.policyNumber)
        formData.append('docName',this.fileenoName)
        formData.append('documentFor',"MGA")
        
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
        formData.append('mgaId',this.mgaId)
        if(this.documentId!=undefined || this.documentId!=null){
          formData.append('documentId',this.documentId)
        }
        // formData.append('province',this.agencyId)
        // formData.append('transitNumber',this.agencyId)
        //  this.fileData=formData
  
        this.uploadImagesMGA(formData)
      }
  
    }
  }else{
    this.overwriteEoMGATest()
        }
  }
  async uploadImagesMGA(formData: FormData) {
    this.loading = true;
    if(this.documentId==null){
    this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      this.isOverWriteEO=false
      this.expiryDate = null;
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.uploadEOPopup = false;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.callAgencyApi=false;
      // this.callMgaAPI=true;
      this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
  
    }, err => {
    });
  }else{
    this.user.OverWriteEO(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      this.isOverWriteEO=false
      this.expiryDate = null;
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.documentId=null;
  
      this.fileId=null;
      this.uploadEOPopup = false;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.callAgencyApi=false;
      // this.callMgaAPI=true;
      this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
    }, err => {
    });
  }
  }
  overwriteEoMGATest(){
  
    const formData = new FormData();
      formData.append('expiryDate', this.expiryDate);
      formData.append('effectiveDate', this.effectiveDate);
        formData.append('policyNumber', this.policyNumber);
        var data = this.leadId
        formData.append('leadId', data);
        // formData.append('agencyId',this.agencyId)
        formData.append('documentId', this.documentId)
        formData.append('fileId', this.fileId)
        formData.append('documentFor',"MGA")
        
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
       
        formData.append('mgaId',this.mgaId)
    this.user.OverWriteEO(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
      this.isOverWriteEO=false
      this.expiryDate = null;
      this.fileeno = "";
      this.fileenoName = "";
      this.policyNumber = "";
      this.finalDocs = data.data;
      this.loading = false;
      this.documentId=null;
  
      this.fileId=null;
      this.uploadEOPopup = !this.uploadEOPopup;
      Swal.fire('', data.message, 'success');
      this.showExpiry = data.data.expiryDate;
      this.showDocumentName = data.data.documentName;
      this.showPolicyNumber = data.data.policyNumber;
      // this.callAgencyApi=false;
      // this.callMgaAPI=true;
      this.openTabs21(this.mgaIndex);
      this.getMGADocuments(this.mgaId,this.mgaIndex)
    }, err => {
    });
  }
  addLicMGA(){
    // this.fileIdlic=licval.fileId
    // this.province=licval.provinces.provinceCode
    // this.licenceId=licval.id;
    var obj={
      "expiryDateLic1":"",
      "effectiveDateLic1":"",
      "provinceCode":undefined,
      "type":undefined,
      "licenseNumber":"",
      "filelicens":"",
      "lincencesName":""
       }
      this.uploadlicenseArray=[]
      this.uploadlicenseArray.push(obj)
      this.fileIdlic=null
      // this.fileenoNameLic=licval.licenseName,
      this.licenceId=null;
      
    }
    uploadlicensefileMGA(uploadlic, i) {

      var flag = true
      var errormsg = [];
      uploadlic.expiryDateLic = this.DatePipe.transform(uploadlic.expiryDateLic1, 'yyyy-MM-dd');
      uploadlic.effectiveDateLic = this.DatePipe.transform(uploadlic.effectiveDateLic1, 'yyyy-MM-dd');
      //if(uploadlic.showemailErrorMsgone==true){}
      if (!uploadlic.filelicens || uploadlic.filelicens.length <= 0 || uploadlic.showemailErrorMsgone == true) { uploadlic.showemailErrorMsgone = true; flag = false; errormsg.push('Choose File') }
      if (!uploadlic.licenseNumber || uploadlic.licenseNumber.length <= 0) { uploadlic.showlicnErrorMsgone = true; flag = false; errormsg.push('Enter License Number') }
      // if(!uploadlic.licenseType || uploadlic.licenseType.length <= 0){uploadlic.showlictErrorMsgone = true;  flag=false; errormsg.push('License Type')} 
      if (!uploadlic.expiryDateLic || uploadlic.expiryDateLic.length <= 0) { uploadlic.showlicdErrorMsgone = true; flag = false; errormsg.push('Enter Expiry Date') }
      if (!uploadlic.provinceCode || uploadlic.provinceCode.length <= 0) { uploadlic.showlicpErrorMsgone = true; flag = false; errormsg.push('Select Province') }
      // if(!uploadlic.licenseName || uploadlic.licenseName.length <= 0){uploadlic.showlicnameErrorMsgone=true;  flag=false; errormsg.push('Provience')} 
      if (!uploadlic.effectiveDateLic || uploadlic.effectiveDateLic.length <= 0) { uploadlic.showlicdErrorMsgEffectiveone = true; flag = false; errormsg.push('Enter Effective Date') }
    
      if (flag == true) {
        this.documentType="LICENSES"
        this.FileUploadLicMGA(uploadlic, i);
  // eyeIconShowAccountNumber: boolean =false;
  // eyeIcon: boolean=false;
  // maskaccountNo: any;
  // showAccountNumber(a) {
  //   //
  //   this.eyeIcon=!this.eyeIcon
  //   if (this.eyeIcon == true){
  //     if(a=='Confirm'){
  //       this.confirmaccountNo  = this.eyeIconShowAccountNumber;
  //     }
  //     else {
  //       this.msg = errormsg.toString();
  //       this.msgfinal = this.msg.replace(",", '<br />');
  //       Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
  //     }
    }
  }
    FileUploadLicMGA(uploadlic, k) {
      this.oricid=uploadlic.oricDocumentId
      if(this.FileDataListLic!=undefined){
      for (var i = 0; i < this.FileDataListLic.length; i++) {
        this.productPhotofile = this.FileDataListLic[i];
        if (this.productPhotofile != null) {
          const formData = new FormData();
          formData.append('file', this.productPhotofile);
          formData.append('expiryDate', uploadlic.expiryDateLic);
          formData.append('effectiveDate', uploadlic.effectiveDateLic);
    
          formData.append('leadId', this.leadId);
          formData.append('DocNumber', uploadlic.licenseNumber);
          formData.append('docName', uploadlic.fileenoNameLic);
          formData.append('licencesType', uploadlic.type);
          formData.append('province', uploadlic.provinceCode);
          // formData.append('agencyId',this.agencyId)
          formData.append('documentFor',"MGA")
          
          formData.append('documentType',this.documentType)
          formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO))
         
          formData.append('mgaId',this.mgaId)
    if(this.fileIdlic!=null || this.licenceId!=null){
    formData.append('fileId', this.fileIdlic);
    formData.append('documentId', this.licenceId);
    }
    if(this.documentId!=null){
    formData.append('documentId', this.documentId)
    }
    if(this.licensRequestId !=null ){
      formData.append('requestedId', this.licensRequestId);
    }
    if(this.oricid!==null && this.oricid!=="" && (this.oricid!==undefined && this.oricid!=="undefined")){
      formData.append('oricDocumentId', this.oricid);
    }
          // this.fileData=formData
    
          this.uploadImagesLicMGA(formData, k)
        }
    
      }
    }
    }
    async uploadImagesLicMGA(formData: FormData, k) {
      
      this.loading = true;
      if(this.licenceId==null){
      this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.uploadLicensePopup = false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
        this.getMGADocuments(this.mgaId,this.mgaIndex)
        //  this.showlicense=true;
        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.isOverWriteEO=false
      }, err => {
    
      });
    }else{
      this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.loading = false;
        this.licenceId=null;
         this.fileIdlic=null;
        Swal.fire('', data.message, 'success');
        // this.getDocument();
        this.uploadLicensePopup = false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
        this.getMGADocuments(this.mgaId,this.mgaIndex)
        // this.showlicense=true;
        this.fileenoNameLic = "";
        this.uploadlicenseArray.splice(k, 1);
        this.uploadlicenseArray.push(data.data)
        this.isOverWriteEO=false
      }, err => {
    
      });
    }
    }
    FileUploadVoidMGA(item, k) {
      
        if(this.FileDataList1!=undefined){
        for (var i = 0; i < this.FileDataList1.length; i++) {
          this.productPhotofile1 = this.FileDataList1[i];
          if (this.productPhotofile1 != null) {
            const formData = new FormData();
            formData.append('file', this.productPhotofile1);
            formData.append('leadId', this.leadId);
            // formData.append('agencyId',this.agencyId)
            //  this.fileData=formData
         formData.append('accountNumber', this.accountNo);
      formData.append('confirmaccountNo', this.confirmaccountNo);
      formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      formData.append('transitNumber', this.transitNo);
      formData.append('bankNumber',this.financialInstitutionNo)
            formData.append('documentFor',"MGA");
                formData.append('documentType',this.documentType)
                formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
                formData.append('mgaId',this.mgaId)
            if(this.fileIdvoid!=null || this.voidchequeId!=null){
              formData.append('fileId', this.fileIdvoid);
               formData.append('documentId', this.voidchequeId);
             
            }
              // this.fileData=formData
      
            this.uploadImagesvoidMGA(formData, k)
          }
      
        }
      }
      else{
        const formData = new FormData();
        // formData.append('file', this.productPhotofile1);
        var data = this.leadId
        formData.append('leadId', data);
        formData.append('documentFor',"MGA");
        formData.append('documentType',this.documentType)
        formData.append('isOverwrite',JSON.stringify(this.isOverWriteEO));
        formData.append('mgaId',this.mgaId)
        formData.append('accountNumber', this.accountNo);
      formData.append('confirmaccountNo', this.confirmaccountNo);
      formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
      formData.append('transitNumber', this.transitNo);
      formData.append('bankNumber',this.financialInstitutionNo)
        //  this.fileData=formData
        if(this.fileIdvoid!=null || this.voidchequeId!=null){
          formData.append('fileId', this.fileIdvoid);
          formData.append('documentId', this.voidchequeId);
         
        }
      
      
        this.uploadImagesvoidMGA(formData, k)
      }
      }
      async uploadImagesvoidMGA(formData: FormData, k) {
      
      this.loading = true;
      if(this.fileIdvoid==null || this.voidchequeId==null){
      this.user.submitFormService(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.isOverWriteEO=false
        this.finalDocs1 = data.data;
        this.loading = false;
        Swal.fire('', data.message, 'success');
        this.uploadVoidChequePopup = false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
        this.getMGADocuments(this.mgaId,this.mgaIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
      
      }, err => {
      
      });
      }else{
      this.user.submitFormService1(this.config.v2AddUpdateBroker, formData).subscribe((data: any) => {
        this.isOverWriteEO=false
        this.finalDocs1 = data.data;
        this.loading = false;
        this.fileIdvoid=null;
        this.voidchequeId=null;
        Swal.fire('', data.message, 'success');
        this.uploadVoidChequePopup= false;
        // this.callAgencyApi=false;
        // this.callMgaAPI=true;
        this.openTabs21(this.mgaIndex);
        this.getMGADocuments(this.mgaId,this.mgaIndex)
        this.showDocumentName1 = data.data.documentName;
        this.fileenoName1 = ""
        this.uploadvoidchequeArray.splice(k, 1);
        this.uploadvoidchequeArray.push(data.data)
      
      }, err => {
      
      });
      }
      }
      uploadVoidMGA(item, i) {
        var flag = true
        var errormsg = [];
        if (!item.fileeno1 || item.fileeno1.length <= 0 || item.showemailErrorMsg1 == true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Choose File') }
        if ( this.voidSizeCheck==true) { this.showemailErrorMsg1 = true; flag = false; errormsg.push('Please upload the filesize less than 4MB')}
        // if(!this.expiryDate || this.expiryDate.length <= 0){this.showdateErrorMsg = true;  flag=false; errormsg.push('Date')} 
      
        if (flag == true) {
          this.documentType="VOID_CHEQUE"
          this.FileUploadVoidMGA(item, i);
      
        }
        else {
          this.msg = errormsg.toString();
          this.msgfinal = this.msg.replace(",", '<br />');
          Swal.fire("", "Please complete the following mandatory field(s):" + "<br>" + this.msgfinal, 'warning')
      
        }
      }
      updateVoidChequeotpVerificationPopup:boolean=false;
      // otpVerificationPopup:boolean=false;
      // otpOfVoidCheque:any;
      // documentIdForOTPVerificationData:any=null;
      onClickOTPValidation1(item){
        if(this.LeadActivated == 'Activated'){
          this.otpOfVoidCheque=null;
          this.documentIdForOTPVerificationData=item;
          const request = {
            "documentId": this.documentIdForOTPVerificationData?.id,
            "otp": ""
          }    
          this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
            // if(data.status==true){
            //   this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
            // }else{
              this.updateVoidChequeotpVerificationPopup=true;
              this.sendOtpForVoidCheque1();
            // }
          },error=>{{
          }},()=>{});
        }else{
          this.uploadVoidChequePopup = true;
        }
      
      }
      
      sendOtpForVoidCheque1(){
        const request = {
          "documentId": this.documentIdForOTPVerificationData?.id,
          "otp": ""
        }    
        this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
          if(data.status==true){
            this.startOtpTimer()
            this.toastr.success("Verification Code sent successfully.");
          }else{
            this.toastr.error(data.message);
          }
        },error=>{{
        }},()=>{});
      }
      verifyOTP1(){
        const request = {
          "documentId": this.documentIdForOTPVerificationData?.id,
          "otp": this.otpOfVoidCheque
        }    
        this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
        if(data.status==true){
            this.uploadVoidChequePopup=true;
            this.updateVoidChequeotpVerificationPopup = false;
            // this.onSelected1(this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.id,this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.fileDownloadUrl,this.documentIdForOTPVerificationData?.fileId)
          }else{
            this.toastr.error("Incorrect Verification Code");
          }
        },error=>{{
        }},()=>{});
      }
      resendVoidChequeOTP1(){
        this.otpOfVoidCheque=null;
        this.updateVoidChequeotpVerificationPopup=true;
        const request = {
          "documentId": this.documentIdForOTPVerificationData?.id,
          "otp": ""
        }    
        this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
          if(data.status==true){
            this.startOtpTimer()
            this.toastr.success("Verification Code sent successfully.");
          }else{
            this.toastr.error(data.message);
          }
        },error=>{{
        }},()=>{});
      }
      
  
  closeBankInfoPopup1(){
    this.fileenoName1 = null;
    this.transitNoErrMsg = false;
    this.financialInstitutionNoErrMsg = false;
    this.accountNoErrMsg = false;
    this.confirmaccountNoErrMsg = false;
    this.confirmAccountNumberMatch = false;
    this.bankinfoChecked = false;
  }
  onClickOTPValidation(item){
    if(this.LeadActivated == 'Activated'){
      this.otpOfVoidCheque=null;
      this.documentIdForOTPVerificationData=item;
      const request = {
        "documentId": this.documentIdForOTPVerificationData?.id,
        "otp": ""
      }    
      this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
        //
        if(data.status==true){
          this.onVoidCheck(this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.fileId)
        }else{
          this.otpVerificationPopup=true;
          this.sendOtpForVoidCheque();
        }
        },error=>{{
        }},()=>{});
    }else{
      this.otpOfVoidCheque=null;
      this.documentIdForOTPVerificationData=item;
      const request = {
        "documentId": this.documentIdForOTPVerificationData?.id,
        "otp": ""
      }    
      this.base.callPostService(this.config.checkAlreadyAuthoriseForVoidCheque, request).subscribe((data:any) =>{
        //
          this.onVoidCheck(this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.fileId)
    
        },error=>{{
        }},()=>{});
    } 
}
sendOtpForVoidCheque(){
  const request = {
    "documentId": this.documentIdForOTPVerificationData?.id,
    "otp": ""
  }    
  this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
    if(data.status==true){
      this.startOtpTimer()
      this.toastr.success("Verification Code sent successfully.");
    }else{
      this.toastr.error(data.message);
    }
  },error=>{{
  }},()=>{});
}
verifyOTP(){
  const request = {
    "documentId": this.documentIdForOTPVerificationData?.id,
    "otp": this.otpOfVoidCheque
  }    
  this.base.callPostService(this.config.verifyOtpForVoidCheque, request).subscribe((data:any) =>{
  if(data.status==true){
      this.otpVerificationPopup=false;
      this.onVoidCheck(this.documentIdForOTPVerificationData?.fileUrl,this.documentIdForOTPVerificationData?.documentName,this.documentIdForOTPVerificationData?.fileId)
    }else{
      this.toastr.success("Incorrect Verification Code");
    }
  },error=>{{
  }},()=>{});
}
resendVoidChequeOTP(){
  this.otpOfVoidCheque=null;
  this.otpVerificationPopup=true;
  const request = {
    "documentId": this.documentIdForOTPVerificationData?.id,
    "otp": ""
  }    
  this.base.callPostService(this.config.sendOtpForVoidCheque, request).subscribe((data:any) =>{
    if(data.status==true){
      this.startOtpTimer()
      this.toastr.success("Verification Code sent successfully.");
    }else{
      this.toastr.error(data.message);
    }
  },error=>{{
  }},()=>{});
}
onEnterKeyPressed(event) {
  if (event.keyCode === 13 && !event.shiftKey) {
    this.verifyOTP();
  }
}
onEnterKeyPressedForVoidCheque(event) {
  if (event.keyCode === 13 && !event.shiftKey) {
    this.verifyOTP1();
  }
}
downloadLeadsDocs(){
  this.user.downloadLeadsDocs(this.leadId).pipe()
  .subscribe(data => {
      window.open(data.data, '_blank');
    }, error => {
  }, () => { });
}
iframemodel: boolean = false;
signCard:boolean=true;
document_hash;
submitLeadAgreement(){
      //debugger
  // let signerRole="Lead"
  this.getMiscDocument();
  this.checkStatus();
  this.updateAgreementStatus();
  this.iframemodel = false;
  this.pdfmodelMisc=false
}
updateAgreementStatus(){
  this.user.updateAgreementStatus(this.leadId).pipe()
  .subscribe(
      data => {
       
       console.log(data)
   
      },error=>{
        //  if(this.baseservice.handleError(error)){
           //handle Exception from Server 404,401
         
         
          },()=>{});
}
checkStatus(){
  //  this.document_hash=undefined
    
  if(this.document_hash!=null || this.document_hash!=undefined){
   const formData = new FormData();
   formData.append('document_hash', this.document_hash);
   this.sendFormDataReq(formData);
 }
}
isSignAgreement:boolean=false;
isCompleted:boolean=false;
contarctPending: any=[];
agreementId: any;
sendFormDataReq(formData: FormData){
  this.user.getSignerStatus(formData).pipe()
  .subscribe(
      data => {
          
        if(data.data !==undefined){
          let  tempRole
          let signerRole
        // let  tempRole=data.data.signers.filter(itm=>itm.role=="Lead" || "Partner")
        for(let m=0;m<data.data.signers.length;m++){
          if(data.data.signers[m].role=="Partner" || data.data.signers[m].role=="Lead" || this.contarctPending[0].signers[m].role=="Agent" || this.contarctPending[0].signers[m].role=="MGA Rep")
          {
           tempRole=data.data.signers[m];
          }
        }
        if(tempRole!=undefined || tempRole!=null){
      this.leadStatus=tempRole.status;
      signerRole=tempRole.role
       }
      
      //  if(this.leadStatus=="signed"){
      //   this.user.updateEverSignStatus(this.leadId,signerRole,this.agreementId).pipe()
      //   .subscribe(
      //       data => {
                
      //         if(data.data !==undefined || data.status==true){
      //           this.getDashboard();  
      //           this.iframemodel = !this.iframemodel;
      //           // Swal.fire('',data.message,'success');
      //           window.location.reload();
      //           } },error=>{
      //             this.iframemodel = !this.iframemodel;
      //              this.error="Something went wrong. Please try again later";
      //            },()=>{});
      //         }
      //         else{
      //           //this.confirmBox();
      //          //this.iframemodel = !this.iframemodel;
      //         // this.confirmBox();
      //         //   setTimeout(function() {
      //         //     $('#successMessage').fadeOut('fast');
      //         // }, 30000); // <-- time in milliseconds
      //           //Swal.fire("", "Please Sign Agreement to Proceed further", 'warning')
                
      //           // this.deleteLeadsPopup = !this.deleteLeadsPopup;
      //           this. closePopup();
      //         }
      this.iframemodel = !this.iframemodel;
      this.getDashboard();  
window.location.reload();
          }
         },error=>{
        if(error.status == 400 || error.status==417){
              this.error=error.error.data;
             }
           else{
             this.error=error.toString();
            
           }
         //  Swal.fire("", this.error , 'error')
          },()=>{});   
}
contractDetails: any=[];
signedStatus: any;
checkedDoc: any;
checkDocdesc: any;
contractId: any;
  contractFileUrl: any;
  Url: any;
  contractFileId: any;
  contractDownloadUrl: any;
  stagesViews:any;
  contractUrl: any;
  showbtn: any;
  personalinfo: any;
  isUploaddoc: boolean = true;
  isCompleteddoc: boolean = true;
  isInprogressUD: boolean = false;
 embeddedSigningUrl
getContract(){
  //var leadId=4;
    
  this.leadId=sessionStorage.getItem('leadId');
  this.user.getContractSignOFLead(this.leadId).pipe()
  .subscribe(
      data => {
            //debugger
          this.contractDetails=[];
          this.contarctPending=[]
        if(data.data !==undefined){
           
         for(let i=0; i<data.data.length;i++){
          this.contractDetails.push(data.data[i]);
          if(this.contractDetails[i].status!="Cancelled"){
            this.contarctPending.push(data.data[i])
        }
        
          }
          for(let m=0;m<this.contarctPending[0].signers.length;m++){
            if(this.contarctPending[0].signers[m].role=="Partner" ||this.contarctPending[0].signers[m].role=="Lead" || this.contarctPending[0].signers[m].role=="Agent" || this.contarctPending[0].signers[m].role=="MGA Rep")
            {
              this.signedStatus=this.contarctPending[0].signers[m].status
            }
          }
          this.agreementId = this.contarctPending[0].id
          this.checkedDoc = this.contarctPending[0].status
          this.checkDocdesc=this.contarctPending[0].description
          if (this.contarctPending[0].fileDownloadUrl != null) {
            if (this.contarctPending[0].files.length != 0) {
              // this.uploaddocs();
              // this.showExpiry = data.data.documents.expiryDate;
              // this.showDocumentName = data.data.documents.documentName;
              // this.showPolicyNumber = data.data.documents.policyNumber;
              // this.finalDocs = data.data.documents;
                  
              this.contractFileUrl = this.contarctPending[0].fileUrl;
              this.contractId = this.contarctPending[0].files.id
            
              this.contractFileId = this.contarctPending[0].fileId

              this.contractDownloadUrl =this.contarctPending[0].fileDownloadUrl;
              this.contractUrl = this.contractDownloadUrl.split('.').pop();
          
              this.checkedDoc = this.contarctPending[0].status
            this.checkDocdesc=this.contarctPending[0].description
            }
          }
            
          this.showbtn=this.personalinfo?.stagesViews[2]?.isEditable
         if(this.stagesViews[1]?.isCompleted === true && this.stagesViews[1]?.isApproved===false){
          this.isUploaddoc = false;
          this.isCompleteddoc = true;
          this.isInprogressUD = true;
         }
          this.document_hash=this.contarctPending[0].documentHash;
          // this.urlSafe="";
          if(this.contarctPending[0]=="No contract Found" || data.success==false){
            this.signCard=true;
          }
          else{
            this.signCard=false;
            if(this.stagesViews[2].isCompleted && this.stagesViews[2].isApproved && data.data.fileUrl!=null){
              if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===true){
                this.isSignAgreement = true;
                this.isCompleted=true;
                }else if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===false){
                  this.isSignAgreement = true;
                  this.isCompleted=false;
                }
              // this.urlSafe= this.contarctPending[0].fileUrl;
            }
            else if(this.stagesViews[2].isCompleted === true && this.stagesViews[2].isApproved===false){
              this.isSignAgreement = true;
              this.isCompleted=false;
            }
              
              this.signCard=false;
              let temp=this.contarctPending[0].signers
              let tempRole
          //  let tempRole=temp.filter(itm=>itm.role=="Lead" ||  "Partner")
          //  let tempRole=temp.filter(itm=>itm.role=="Lead" || Prtner)
          for(let m=0;m<this.contarctPending[0].signers.length;m++){
            if(this.contarctPending[0].signers[m].role=="Partner" || this.contarctPending[0].signers[m].role=="Lead" || this.contarctPending[0].signers[m].role=="Agent" || this.contarctPending[0].signers[m].role=="MGA Rep")
            {
             tempRole=this.contarctPending[0].signers[m];
            }
          }
            if(tempRole!=undefined || tempRole!=null){
    
              this.embeddedSigningUrl=tempRole.embeddedSigningUrl
              // this.urlSafe= this.embeddedSigningUrl;
            
            }
            // else{ this.urlSafe=""}
          
           
          }
          
      }
         },error=>{
     
          if(error.status == 400 || error.status==417){
              this.error=error.error.data;
             
           }
           else{
             
             this.error="Something went wrong. Please check username and password.";
           }
           this.signCard=true;
          },()=>{});
}
closePopup(){
  // this.deleteLeadsPopup = !this.deleteLeadsPopup;
  
   this.iframemodel = !this.iframemodel;
  // this.submitLeadAgreement();
}
openDocumentLOI(data,type){
  //debugger
 if(type == 'LOI'){
  this.urlSafe = data;
  this.iframemodel = !this.iframemodel;
 }
 if(type == 'TRAINING_DECLARATION'){
  this.urlSafe = data;
  this.iframemodel = !this.iframemodel;
 }
}
tabs21 = [
  { active21: '', tabcontent21: 'hide' }, // First tab is active by default
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
  { active21: '', tabcontent21: 'hide' },
];
  openTabs21(index){
    //debugger
    this.reset21();
    this.reset2();
    this.reset22();
    this.tabs21[index].active21 = 'active21';
    this.tabs21[index].tabcontent21 = 'tabcontent21';
      this.showLicTypeonPopup=this.MgaLicType;
  }
  
  
  reset21() {
    for (let i = 0; i < this.tabs21.length; i++) {
      this.tabs21[i].active21 = '';  // Deactivate all tabs
      this.tabs21[i].tabcontent21 = 'hide';  // Hide all tab content
    }
  }
  tabs22 = [
    { active22: '', tabcontent22: 'hide' }, // First tab is active by default
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
    { active22: '', tabcontent22: 'hide' },
  ];
    openTabs22(index){
      //debugger
      this.reset21();
      this.reset2();
      this.reset22();
      this.tabs22[index].active22 = 'active22';
      this.tabs22[index].tabcontent22 = 'tabcontent22';
     
        this.showLicTypeonPopup=this.corporateLicType;
      
    
    }
    
    
    reset22() {
      for (let i = 0; i < this.tabs22.length; i++) {
        this.tabs22[i].active22 = '';  // Deactivate all tabs
        this.tabs22[i].tabcontent22 = 'hide';  // Hide all tab content
      }
    }
    clickOnRequestMga(id){
      this.licenceId=null;
      this.licensRequestId=id;
      var obj={
        "expiryDateLic1":"",
        "effectiveDateLic1":"",
        "provinceCode":undefined,
        "type":undefined,
        "licenseNumber":"",
        "filelicens":"",
        "lincencesName":""
         }
        this.uploadlicenseArray=[]
        this.uploadlicenseArray.push(obj)
    //  this.uploadnewLicensePopup = true;
    // this.uploadLicensePopup = !this.uploadLicensePopup;
     this.showCompanyDelete=false;
     this.callMgaAPI=true;
     this.showLicTypeonPopup=this.corporateLicType;
    }
    requestLicensarrayEO=[]
    getEORequest(){
        this.user.getLicenseRequestCall(this.leadId,'EO').pipe()
      .subscribe(
          data => {
            if(data.status==true){
            this.requestLicensarrayEO=[]
            this.requestLicensarrayEO=data.data
            }else{
            this.requestLicensarrayEO=[]
            }
          },error=>{
              },()=>{});
      }
      requestLicensarrayVoidCheque=[]
    getVoidChequeRequest(){
        this.user.getLicenseRequestCall(this.leadId,'VOID_CHEQUE').pipe()
      .subscribe(
          data => {
            if(data.status==true){
            this.requestLicensarrayVoidCheque=[]
            this.requestLicensarrayVoidCheque=data.data
            }else{
            this.requestLicensarrayVoidCheque=[]
            }
          },error=>{
              },()=>{});
      }
      OverwriteEODocRequested(data) {
          this.requestedData=data
          this.isDocumentRequested = true
          if (data.type == 'LINCENCES') {
            this.uploadLicensePopup = true;
          }
          if (data.type == 'EO') {
            this.expiryDate = "";
          this.effectiveDate = "";
          this.fileeno = "";
          this.fileenoName = "";
          this.policyNumber = "";
            this.uploadEOPopup = true
          }
          if (data.type == 'VOID_CHEQUE') {
            // this.editBankInfo()
            this.transitNo =null;
            this.financialInstitutionNo=null;
            this.accountNo=null;
            this.confirmaccountNo =null;
            this.maskaccountNo =null;
            this.eyeIconShowAccountNumber =null;
            this.bankinfoChecked = false;
            this.fileIdvoid=null; 
            this.voidchequeId=null;
            this.finalDocs1 = data.data;
            this.loading = false;
            this.BankInfo = false;
    this.fileenoName1 = ""
    this.fileeno1 = ""
    this.uploadVoidChequePopup=true
          }
        }
        RequestedDocumentAddUpdateEO(type) {
          let docFor = '';
      if (!this.showCompanyDelete && !this.callMgaAPI) {
        docFor = 'LEAD';
      } else if (this.showCompanyDelete && !this.callMgaAPI) {
        docFor = 'Agency';
      } else if (!this.showCompanyDelete && this.callMgaAPI) {
        docFor = 'MGA';
      }
          const formData = new FormData();
          formData.append('file', this.FileDataList[0]);
          formData.append('expiryDate', this.expiryDate);
          formData.append('effectiveDate', this.effectiveDate);
          formData.append('leadId', this.leadId);
          // formData.append('agencyId',this.agencyId)
          formData.append('DocNumber',this.policyNumber)
          // formData.append('accountNumber',this.agencyId)
          // formData.append('bankNumber',this.policyNumber)
          formData.append('docName',this.fileenoName)
          formData.append('documentFor',docFor)
          
          formData.append('documentType',type)
          formData.append('isOverwrite','true')   
      if(this.showCompanyDelete==true){
                formData.append('agencyId ', this.agencyId);
              }
      if(this.callMgaAPI==true){
      formData.append('mgaId',this.mgaId)
              }
          if( this.requestedData.documentId!=undefined || this.requestedData.documentId!=null){
            formData.append('documentId', this.requestedData.documentId)
          }
          formData.append('requestedId', this.requestedData.id);
          this.uploadRequestedDoc(formData)
        }
        RequestedDocumentAddUpdateLic(uploadlic, k,type) {
          let docFor = '';
          if (!this.showCompanyDelete && !this.callMgaAPI) {
            docFor = 'LEAD';
          } else if (this.showCompanyDelete && !this.callMgaAPI) {
            docFor = 'Agency';
          } else if (!this.showCompanyDelete && this.callMgaAPI) {
            docFor = 'MGA';
          }
          const formData = new FormData();
          formData.append('file',this.FileDataListLic[0]);
          formData.append('expiryDate', uploadlic.expiryDateLic);
          formData.append('effectiveDate', uploadlic.effectiveDateLic);
      
          formData.append('leadId', this.leadId);
          formData.append('DocNumber', uploadlic.licenseNumber);
          // formData.append('docName', uploadlic.licenseName);
          formData.append('licencesType', uploadlic.type);
          formData.append('province', uploadlic.provinceCode);
          // formData.append('agencyId',this.agencyId)
          formData.append('documentFor',docFor)
          
          formData.append('documentType',type)
          formData.append('isOverwrite','false')    
      if(this.showCompanyDelete==true){
                formData.append('agencyId ', this.agencyId);
              }
      if(this.callMgaAPI==true){
      formData.append('mgaId',this.mgaId)
              }
      
      if(this.requestedData.id !=null ){
      formData.append('requestedId', this.requestedData.id);
      }
          // this.fileData=formData
      
          this.uploadRequestedDoc(formData)
        }
        RequestedDocumentAddUpdateVoid(uploadlic, k,type) {
          let docFor = '';
          if (!this.showCompanyDelete && !this.callMgaAPI) {
            docFor = 'LEAD';
          } else if (this.showCompanyDelete && !this.callMgaAPI) {
            docFor = 'Agency';
          } else if (!this.showCompanyDelete && this.callMgaAPI) {
            docFor = 'MGA';
          }
          const formData = new FormData();
          formData.append('file', this.FileDataList1[0]);
          formData.append('leadId', this.leadId);
          formData.append('accountNumber', this.accountNo);
          formData.append('confirmaccountNo', this.confirmaccountNo);
          formData.append('finacialInsitutionNumber', this.financialInstitutionNo);
          formData.append('transitNumber', this.transitNo);
          formData.append('bankNumber',this.financialInstitutionNo)
          formData.append('documentFor',docFor);
              formData.append('documentType',type)
              formData.append('isOverwrite','true');
      if(this.showCompanyDelete==true){
                  formData.append('agencyId ', this.agencyId);
                }
      if(this.callMgaAPI==true){
        formData.append('mgaId',this.mgaId)
                }
              
          if(this.fileIdvoid!=null ){
            formData.append('fileId', this.fileIdvoid);
          }
          if(this.requestedData.documentId!=null){        
              formData.append('documentId', this.requestedData.documentId);
          }
          if(this.requestedData.id!=null){     
          formData.append('requestedId', this.requestedData.id);
          }
          this.uploadRequestedDoc(formData)
        }
      
        uploadRequestedDoc(formData){
          this.loading = true;
          this.user.submitFormService(this.config.v2GetRequestedDocumentAddUpdate, formData).subscribe((data: any) => {
            this.loading = false;
            this.isDocumentRequested = false
            this.uploadEOPopup = false
            this.uploadVoidChequePopup = false
            this.uploadLicensePopup = false;
            this.getLicensRequest();
            this.getEORequest();
            this.getVoidChequeRequest();   
            Swal.fire({
              text: data.message,  
              icon: 'success',      
              confirmButtonColor: '#CC4037',       
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {
            // this.ProceedPromt();      
          }
        }) 
            
            //  this.showlicense=true;
            this.fileenoNameLic = "";
            // this.uploadlicenseArray.splice(k, 1);
            // this.uploadlicenseArray.push(data.data)
          }, err => {
        
          });  
        }
        startOtpTimer() {
          this.remainingSecondsSIN = 300; // 5 minutes = 300 seconds
          this.isOtpExpiredSIN = false;
          this.updateTimerDisplay();
        
          if (this.otpTimerSIN) {
            clearInterval(this.otpTimerSIN);
          }
        
          this.otpTimerSIN = setInterval(() => {
            if (this.remainingSecondsSIN > 0) {
              this.remainingSecondsSIN--;
              this.updateTimerDisplay();
            } else {
              //debugger
              this.isOtpExpiredSIN = true;
              clearInterval(this.otpTimerSIN);
            }
          }, 1000);
        }
        
        updateTimerDisplay() {
          const minutes = Math.floor(this.remainingSecondsSIN / 60);
          const seconds = this.remainingSecondsSIN % 60;
          this.otpTimerDisplaySIN = `${this.pad(minutes)}:${this.pad(seconds)}`;
        }
        
        pad(value: number): string {
          return value < 10 ? '0' + value : value.toString();
        }
}

